// Mock data for VIYERO product showcase

export const gamingProducts = [
  {
    id: 'g2',
    name: 'GD-12002E-2-BLK',
    displayName: {
      en: 'Gaming Desk\nwith RGB Lighting',
      tr: 'RGB Aydınlatmalı\nOyuncu Masası'
    },
    category: 'Gaming Desks',
    type: 'gaming',
    model: 'GD-12002E-2-BLK',
    shortDesc: {
      en: 'Gaming desk with integrated RGB lighting for immersive gaming experience',
      tr: 'Sürükleyici bir oyun deneyimi için entegre RGB aydınlatmalı oyuncu masası'
    },
    fullDesc: {
      en: 'Unparalleled gaming experiences are built by reliable functional support and immersive entertainment atmosphere. GD-12002E is hereby designed to make your enjoyment top-notch. The built-in lighting control with 18 effects enhances customizable gameplay ambiance while guaranteeing a minimalist look with easy accessibility. The decorative stickers further add stylish color to the desk. Distraction-free entertainment is ensured by on-desk and under-desk organizing solutions. The curved front edge ensures a comfortable sitting posture, and the round corners prevents accidental bumping. With anti-slip leveling feet, the desk adapts to most uneven floors.',
      tr: 'Benzersiz oyun deneyimleri, güvenilir işlevsel destek ve sürükleyici bir eğlence atmosferi üzerine inşa edilir. GD-12002E, aldığınız keyfi en üst seviyeye çıkarmak için özel olarak tasarlanmıştır. 18 farklı efekte sahip dahili aydınlatma kontrolü, kolay erişilebilirliği ve minimalist görünümü korurken, oyun atmosferinizi özelleştirmenize olanak tanır. Dekoratif çıkartmalar ise masaya şık bir renk katar. Masa üstü ve masa altı düzenleme çözümleri sayesinde dikkatiniz dağılmadan eğlenceye odaklanmanız sağlanır. Kavisli ön kenar konforlu bir oturuş pozisyonu sunarken, yuvarlatılmış köşeler olası çarpmaları ve kazaları önler. Kaymaz dengeleme ayakları sayesinde masa, engebeli zeminlerin çoğuna mükemmel uyum sağlar.'
    },
    features: [
      { en: 'RGB Multi-Color Lights: offer cool ambient lighting', tr: 'RGB Çok Renkli Işıklar: Havalı bir ortam aydınlatması sunar.' },
      { en: 'Z-shaped Legs Design: provides both stability and distinctive aesthetics', tr: 'Z-Tasarım Ayaklar: Hem stabilite (denge) hem de özgün bir estetik sağlar.' },
      { en: 'Under-Desk headphone & cup holders create a clutter-free desktop.', tr: 'Masa Altı Kulaklık ve Bardak Tutucular: Dağınıklıktan uzak bir masaüstü alanı yaratır.' },
      { en: 'Round Protective Edge: prevents accident bumping for safety', tr: 'Yuvarlatılmış Koruyucu Kenarlar: Güvenlik için çarpma kaynaklı kazaları önler.' },
      { en: 'Leveling Feet: adapt to most uneven floor or surface', tr: 'Dengeleme Ayakları: Çoğu engebeli zemin veya yüzeye uyum sağlar.' },
      { en: 'Desktop Built-in Lighting Control: easier to reach with a minimalist look', tr: 'Masaüstü Dahili Aydınlatma Kontrolü: Minimalist görünümüyle erişimi daha kolaydır.' },
      { en: 'Customizable Decorative Stickers: add color for vibrant ambience', tr: 'Özelleştirilebilir Dekoratif Çıkartmalar: Canlı bir atmosfer için renk katar.' },
      { en: 'Curved Front Edge: for comfort and increased productivity', tr: 'Kavisli Ön Kenar: Konfor ve artırılmış verimlilik sağlar.' },
      { en: 'Cable Management Holes: easy to organize messy cords for a clean look', tr: 'Kablo Yönetim Delikleri: Karışık kabloları düzenleyerek temiz bir görünüm sunar.' }
    ],
    specs: {
      en: {
        'Product Category': 'Gaming Desk',
        'Rank': 'Standard',
        'Material': 'MDF & Melamine, Plastic, Steel',
        'Dimensions': '1200x600x750mm',
        'Tabletop Size': '1200x600x15mm',
        'Weight Capacity': '75kg (165lbs)',
        'Ambient Lighting': 'Multi-Color Gradient Breathing LED Light',
        'USB Port': 'No',
        'Multi-Media Port': 'No',
        'Color Options': 'Black & Matte Black, Black & Matte Red',
        'Certification': 'CE, FCC',
        'Accessory Kit Package': 'Normal/Ziplock Polybag',
        'Silk Screen Printing': 'Applicable (For custom logo/pattern)',
        'Drink Holder': 'Yes',
        'Headphone Hook': 'Yes',
        'Cable Management Tray': 'No',
        'Back Panel (Baffle)': 'No'
      },
      tr: {
        'Ürün Kategorisi': 'Oyuncu Masası',
        'Segment': 'Standart',
        'Malzeme': 'MDF & Melamin, Plastik, Çelik',
        'Boyutlar': '1200 x 600 x 750 mm',
        'Tabla Yüzey Boyutu': '1200 x 600 x 15 mm',
        'Taşıma Kapasitesi': '75 kg (165 lbs)',
        'Ambians Aydınlatma': 'Çok Renkli Gradyan Nefes Alan LED Işık',
        'USB Portu': 'Yok',
        'Multimedya Portu': 'Yok',
        'Renk Seçenekleri': 'Siyah & Mat Siyah, Siyah & Mat Kırmızı',
        'Sertifikalar': 'CE, FCC',
        'Aksesuar Paketi': 'Normal / Kilitli (Ziplock) Polietilen Torba',
        'Serigrafi Baskı': 'Uygulanabilir (Özel logo/desen için)',
        'Bardak Tutucu': 'Var',
        'Kulaklık Askısı': 'Var',
        'Kablo Yönetim Tepsisi': 'Yok',
        'Arka Panel (Baffle)': 'Yok'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-home-1/artifacts/lbxj02ds_Genel%20%20GD-12002E-2-BLK.png',
      'https://customer-assets.emergentagent.com/job_gaming-home-1/artifacts/o5uvrcvy_RGB%20GD-12002E-2-BLK.png',
      'https://customer-assets.emergentagent.com/job_gaming-home-1/artifacts/tlvlwa34_Headphone%20GD-12002E-2-BLK.png'
    ],
    relatedProducts: ['g4', 'g5']
  },
  {
    id: 'g4',
    name: 'GD-12002E-6-BLK',
    displayName: {
      en: 'Stylish Gaming Desk with RGB Lighting',
      tr: 'Yükseltilmiş Ayaklı RGB\nOyuncu Masası'
    },
    category: 'Gaming Desks',
    type: 'gaming',
    model: 'GD-12002E-6-BLK',
    shortDesc: {
      en: 'Stylish gaming desk featuring RGB lighting and distinctive Z-shaped legs',
      tr: 'RGB aydınlatmalı, şık ve kendine özgü Z-tasarım ayaklı oyuncu masası'
    },
    fullDesc: {
      en: 'Elevate your gaming setup with the GD-12002E-6-BLK featuring a modern design with tilted Z-shaped legs and integrated RGB lighting. Combines aesthetics with functionality for the ultimate gaming station.',
      tr: 'Eğimli Z-tasarım ayakları ve entegre RGB aydınlatmasıyla modern bir görünüme sahip olan GD-12002E-6-BLK ile oyun alanınızı bir üst seviyeye taşıyın. Kusursuz bir oyun istasyonu için estetiği işlevsellikle birleştirir.'
    },
    features: [
      { en: 'RGB Multi-Color Lights: offer cool ambient lighting', tr: 'RGB Çok Renkli Işıklar: Havalı bir ortam aydınlatması sunar.' },
      { en: 'Z-shaped Legs Design: provides both stability and distinctive aesthetics', tr: 'Z-Tasarım Ayaklar: Hem denge hem de özgün bir estetik sağlar.' },
      { en: 'Under-Desk headphone & cup holders create a clutter-free desktop.', tr: 'Masa Altı Kulaklık ve Bardak Tutucular: Dağınıklıktan uzak bir masaüstü alanı yaratır.' },
      { en: 'Round Protective Edge: prevents accident bumping for safety', tr: 'Yuvarlatılmış Koruyucu Kenarlar: Güvenlik için çarpma kaynaklı kazaları önler.' },
      { en: 'Desktop Built-in Lighting Control: easier to reach with a minimalist look', tr: 'Masaüstü Dahili Aydınlatma Kontrolü: Minimalist görünümüyle erişimi kolaylaştırır.' },
      { en: 'Customizable Decorative Stickers: add color for vibrant ambience', tr: 'Özelleştirilebilir Dekoratif Çıkartmalar: Canlı bir atmosfer için masaya renk katar.' },
      { en: 'Curved Back Edge: allows the desk to sit flush against the wall while enabling easy cable management and monitor stand mounting', tr: 'Kavisli Arka Kenar: Masanın duvara tam sıfır yanaşmasını sağlarken, kolay kablo yönetimi ve monitör standı montajına imkan tanır.' },
      { en: 'Leveling Feet: adapt to most uneven floor or surface', tr: 'Dengeleme Ayakları: Çoğu engebeli zemin veya yüzeye uyum sağlar.' }
    ],
    specs: {
      en: {
        'Product Category': 'Gaming Desk',
        'Model': 'GD-12002E-6-BLK',
        'Rank': 'Standard',
        'Material': 'Particle Board & Melamine, Plastic, Steel',
        'Dimensions': '1200x600x750mm',
        'Weight Capacity': '75kg (165lbs)',
        'Ambient Lighting': 'Multi-Color RGB LED Light',
        'Leg Design': 'Tilted Z-Shaped',
        'Color': 'Black'
      },
      tr: {
        'Ürün Kategorisi': 'Oyuncu Masası',
        'Model': 'GD-12002E-6-BLK',
        'Segment': 'Standart',
        'Malzeme': 'Sunta & Melamin, Plastik, Çelik',
        'Boyutlar': '1200x600x750 mm',
        'Taşıma Kapasitesi': '75 kg (165 lbs)',
        'Ambians Aydınlatma': 'Çok Renkli RGB LED Işık',
        'Ayak Tasarımı': 'Eğimli Z-Tasarım',
        'Renk': 'Siyah'
      }
    },
    cardImage: 'https://customer-assets.emergentagent.com/job_gaming-home-1/artifacts/2d3m72hy_GD-12002E-6-BLK%20%20%20%20gameboy-2.png',
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-home-1/artifacts/sjt05ujy_GD-12002E-6-BLK%20%20w%20CocaCola-2%20%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-home-1/artifacts/7a8sd2oq_GD12002E-6-BLK%20HEADPHONES.png'
    ],
    relatedProducts: ['g2', 'g5']
  },
  {
    id: 'g5',
    name: 'GD-13608-2-BLK',
    displayName: {
      en: 'Gaming Desks\nwith RGB Lighting Edges',
      tr: 'T Ayaklı, 360° RGB\nOyuncu Masası'
    },
    category: 'Gaming Desks',
    type: 'gaming',
    model: 'GD-13608-2-BLK',
    shortDesc: {
      en: 'Experience total immersion with the GD-13608\'s integrated fiber-optic edge lighting',
      tr: 'GD-13608\'in her açıyı saran 360° fiber optik aydınlatmasıyla kendinizi tamamen oyunun içinde hissedin'
    },
    fullDesc: {
      en: 'Experience total immersion with the GD-13608\'s integrated fiber-optic edge lighting, designed to set the perfect mood for every battle. Keep your focus on the game with dual cable management grommets that ensure a clean, clutter-free setup. Built for stability, the premium Cold Rolled Steel I-frame features a refined metallic finish and supports up to 75kg.',
      tr: 'Her karşılaşmaya uygun mükemmel atmosferi yaratmak için tasarlanan GD-13608\'in entegre 360° fiber optik kenar aydınlatmasıyla kendinizi tamamen oyunun içinde hissedin. Temiz ve düzenli bir kurulum sağlayan çift kablo yönetim yuvaları sayesinde odağınızı her zaman oyunda tutun. Üstün stabilite için üretilen birinci sınıf Soğuk Haddelenmiş Çelik iskelet, şık metalik kaplamasıyla 75 kg\'a kadar yük taşıma kapasitesi sunar.'
    },
    features: [
      { en: 'High Weight Capacity: Durable structure for heavier loads', tr: 'Yüksek Taşıma Kapasitesi: Daha fazla ağırlığa karşı dayanıklı yapı.' },
      { en: 'RGB Multi-Color Lights: Provide cool ambient lighting', tr: 'RGB Çok Renkli Işıklar: Havalı bir ortam aydınlatması sağlar.' },
      { en: 'Spacious Desktop Area: Offers ample space for different tasks and more devices', tr: 'Geniş Masaüstü Alanı: Farklı görevler ve daha fazla cihaz için geniş yer sunar.' },
      { en: 'Hidden Cable Management System: Keeps clutter out of sight', tr: 'Gizli Kablo Yönetim Sistemi: Dağınıklığı gözden uzak tutar.' },
      { en: 'Textured Surface: Adds a high-tech feel to the gaming environment', tr: 'Dokulu Yüzey: Oyun ortamına daha yüksek teknoloji hissi katar.' },
      { en: 'Under-Desk headphone & cup holders: Create a clutter-free desktop', tr: 'Masa Altı Kulaklık ve Bardak Tutucular: Dağınıklıktan uzak bir masaüstü alanı yaratır.' }
    ],
    specs: {
      en: {
        'Product Category': 'Gaming Desk',
        'Model': 'GD-13608-2-BLK',
        'Rank': 'Standard',
        'Material': 'Particle Board & Melamine, Plastic, Steel',
        'Dimensions': '1360x600x750mm (53.5"x23.6"x29.5")',
        'Tabletop Size (LxWxT)': '1360x600x18mm (53.5"x23.6"x0.71")',
        'Weight Capacity': '75kg (165lbs)',
        'Ambient Lighting': 'Multi-Color Gradient Breathing LED Light',
        'USB Port': 'No',
        'Multi-Media Port': 'No',
        'Color': 'Black & Matte Black',
        'Certification': 'CE, FCC, UKCA',
        'Accessory Kit Package': 'Normal/Ziplock Polybag',
        'Drink Holder': 'Yes',
        'Headphone Hook': 'Yes'
      },
      tr: {
        'Ürün Kategorisi': 'Oyuncu Masası',
        'Model': 'GD-13608-2-BLK',
        'Segment': 'Standart',
        'Malzeme': 'Yongalı Levha & Melamin, Plastik, Çelik',
        'Boyutlar': '1360 x 600 x 750 mm',
        'Tabla Yüzey Boyutu': '1360 x 600 x 18 mm',
        'Taşıma Kapasitesi': '75 kg (165 lbs)',
        'Ambians Aydınlatma': 'Çok Renkli Breathing Gradient LED Işık',
        'USB Portu': 'Yok',
        'Multimedya Portu': 'Yok',
        'Renk': 'Siyah & Mat Siyah',
        'Sertifikalar': 'CE, FCC, UKCA',
        'Aksesuar Paketi': 'Normal / Kilitli (Ziplock) Polietilen Torba',
        'Bardak Tutucu': 'Var',
        'Kulaklık Askısı': 'Var'
      }
    },
    images: [
      'https://images.unsplash.com/photo-1617507171089-6cb9aa5add36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxnYW1pbmclMjBkZXNrfGVufDB8fHx8MTc2ODMwMjQ5N3ww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1621743018966-29194999d736?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxnYW1pbmclMjBkZXNrfGVufDB8fHx8MTc2ODMwMjQ5N3ww&ixlib=rb-4.1.0&q=85'
    ],
    relatedProducts: ['g2', 'g4']
  },
  {
    id: 'g1',
    name: 'ProArm Gaming X1',
    category: 'Monitor Arms',
    type: 'gaming',
    shortDesc: 'Premium single monitor arm with RGB lighting',
    fullDesc: 'The ProArm Gaming X1 is engineered for serious gamers who demand precision and style. Featuring customizable RGB lighting, smooth gas-spring adjustment, and cable management system.',
    features: [
      'Supports monitors up to 32" and 9kg',
      'Customizable RGB lighting with 16.8M colors',
      'Gas-spring height adjustment',
      'Built-in cable management',
      'VESA 75x75 and 100x100 compatible',
      'Tool-free installation'
    ],
    specs: {
      maxWeight: '9kg (19.8 lbs)',
      maxScreenSize: '32 inches',
      vesaCompatibility: '75x75mm, 100x100mm',
      armReach: '475mm',
      tiltRange: '+85° / -30°',
      swivel: '180°',
      rotation: '360°'
    },
    images: [
      'https://images.unsplash.com/photo-1646771032500-27b440b2d947?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxnYW1pbmclMjBtb25pdG9yJTIwYXJtfGVufDB8fHx8MTc2ODMwMjQ5MXww&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1687289691702-2df29c588435?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHxnYW1pbmclMjBtb25pdG9yJTIwYXJtfGVufDB8fHx8MTc2ODMwMjQ5MXww&ixlib=rb-4.1.0&q=85'
    ]
  },
  {
    id: 'g3',
    name: 'RGBHub Gaming Suite',
    category: 'Accessories',
    type: 'gaming',
    shortDesc: 'Complete RGB accessory bundle for gaming setups',
    fullDesc: 'Elevate your gaming environment with the RGBHub Gaming Suite. This comprehensive accessory pack includes RGB mouse pad, headphone stand, and cable organizer, all synchronized for a cohesive lighting experience.',
    features: [
      'RGB mouse pad (900mm x 400mm)',
      'Aluminum headphone stand with RGB',
      'Magnetic cable organizer',
      'Synchronized RGB control',
      'USB hub with 4 ports',
      'Non-slip rubber base'
    ],
    specs: {
      mousePadSize: '900mm x 400mm x 4mm',
      rgbZones: '12 independent zones',
      usbPorts: '4x USB 3.0',
      connectivity: 'USB-A',
      compatibility: 'Windows, macOS, Linux',
      cable: '1.8m braided cable'
    },
    images: [
      'https://images.unsplash.com/photo-1688789194475-859b4aced595?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxnYW1pbmclMjBhY2Nlc3Nvcmllc3xlbnwwfHx8fDE3NjgzMDI1MDN8MA&ixlib=rb-4.1.0&q=85',
      'https://images.unsplash.com/photo-1581351123004-757df051db8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxnYW1pbmclMjBhY2Nlc3Nvcmllc3xlbnwwfHx8fDE3NjgzMDI1MDN8MA&ixlib=rb-4.1.0&q=85'
    ]
  },
  // Gaming Monitor Arms
  {
    id: 'g-ma1',
    name: 'MA13-S1732-BLK',
    model: 'MA13-S1732-BLK',
    displayName: {
      en: 'Economic Spring-Supported\nMonitor Arm',
      tr: 'Yay Destekli\nMonitör Kolu'
    },
    category: 'Gaming Monitor Arms',
    type: 'gaming',
    shortDesc: {
      en: 'For most 17"-32" Monitors',
      tr: '17"-32" Monitörler için'
    },
    fullDesc: {
      en: 'The MA13-S1732-BLK offers excellent value with smooth spring-supported adjustment. Perfect for home offices and workstations requiring flexible monitor positioning.',
      tr: 'MA13-S1732-BLK, yumuşak yay destekli ayarlamasıyla mükemmel değer sunar. Esnek monitör konumlandırması gerektiren ev ofisleri ve iş istasyonları için idealdir.'
    },
    features: [
      { en: 'Keyhole Pattern: allows for easy installation', tr: 'Anahtar Deliği Deseni: kolay kurulum sağlar' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gergi Mekanizması: mükemmel ağırlık ayarları için' },
      { en: 'Two Mounting Options: both desk clamp and grommet are included', tr: 'İki Montaj Seçeneği: hem masa kelepçesi hem de grommet dahildir' },
      { en: 'Built-in Cable Management: for an organized and neat workspace', tr: 'Dahili Kablo Yönetimi: düzenli ve temiz bir çalışma alanı için' }
    ],
    specs: {
      en: {
        'Product Category': 'Mechanical Spring Monitor Arm',
        'Rank': 'Standard',
        'Material': 'Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black',
        'Dimensions': '117x478x585mm (4.6"x18.8"x23")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '1',
        'Weight Capacity (per screen)': '2~9kg (4.4~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+90°~-45°',
        'Swivel Range': '+90°~-90°',
        'Screen Rotation': '+180°~-180°',
        'Arm Full Extension': '450mm (17.7")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~80mm, Grommet: 10~45mm',
        'Quick Release VESA Plate': 'No',
        'USB Port': 'No',
        'Cable Management': 'Yes',
        'Accessory Kit Package': 'Normal/Ziplock Polybag, Compartment Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Mekanik Yay Monitör Kolu',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Siyah',
        'Boyutlar': '117x478x585mm (4.6"x18.8"x23")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '1',
        'Taşıma Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'VESA Uyumluluğu': '75x75, 100x100',
        'Eğim (Tilt) Aralığı': '+90°~-45°',
        'Dönüş (Swivel) Aralığı': '+90°~-90°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'Kol Tam Uzatma': '450mm (17.7")',
        'Kurulum Tipi': 'Kıskaç (Clamp), Delikli Yüzey (Grommet)',
        'Önerilen Masaüstü Kalınlığı': 'Kelepçe: 10~80mm, Grommet: 10~45mm',
        'Hızlı Çıkarma VESA Plakası': 'Hayır',
        'USB Portu': 'Yok',
        'Kablo Yönetimi': 'Var',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba, Bölmeli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/4pjaaw6w_GAMING%20%201a%20%20%20MA13-S1732-BLK%20.jpg'
    ]
  },
  {
    id: 'g-ma2',
    name: 'MA13-D1732-BLK',
    model: 'MA13-D1732-BLK',
    displayName: {
      en: 'Economy Dual-Screen\nSpring-Assisted Monitor Arm',
      tr: 'Çift Ekran\nYay Destekli Monitör Kolu'
    },
    category: 'Gaming Monitor Arms',
    type: 'gaming',
    shortDesc: {
      en: 'For most 17"-32" Monitors',
      tr: '17"-32" Monitörler için'
    },
    fullDesc: {
      en: 'The MA13-D1732-BLK Monitor Arm provides the user with proper ergonomic viewing with both function and affordability. Perfect for home or office environment with two mounting options- clamp and grommet. Its VESA plate with keyhole slots is designed for quick installation and removal. Quality spring tension mechanism ensures great weight balance for monitors. The quick-release joint allows easy assembly and compact packaging for e-commerce sellers. The MA13-D1732-BLK is a good choice to save both time and money while getting the work area more clean and organized!',
      tr: 'MA13-D1732-BLK Monitör Kolu, kullanıcıya hem işlevsellik hem de uygun fiyatla doğru ergonomik görüntüleme sağlar. Kelepçe ve grommet olmak üzere iki montaj seçeneğiyle ev veya ofis ortamı için mükemmeldir. Anahtar delikli VESA plakası, hızlı kurulum ve çıkarma için tasarlanmıştır. Kaliteli yay gergi mekanizması, monitörler için mükemmel ağırlık dengesi sağlar. Hızlı çıkarma eklemi, e-ticaret satıcıları için kolay montaj ve kompakt paketleme imkanı sunar. MA13-D1732-BLK, çalışma alanını daha temiz ve düzenli hale getirirken hem zamandan hem de paradan tasarruf etmek için iyi bir seçimdir!'
    },
    features: [
      { en: 'Keyhole Pattern: allows for easy installation', tr: 'Anahtar Deliği Deseni: kolay kurulum sağlar' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gergi Mekanizması: mükemmel ağırlık ayarları için' },
      { en: 'Two Mounting Options: both desk clamp and grommet are included', tr: 'İki Montaj Seçeneği: hem masa kelepçesi hem de grommet dahildir' },
      { en: 'Built-in Cable Management: for an organized and neat workspace', tr: 'Dahili Kablo Yönetimi: düzenli ve temiz bir çalışma alanı için' }
    ],
    specs: {
      en: {
        'Product Category': 'Mechanical Spring Monitor Arm',
        'Rank': 'Standard',
        'Material': 'Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black',
        'Dimensions': '937x111x585mm (36.9"x4.4"x23")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '2',
        'Weight Capacity (per screen)': '2~9kg (4.4~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+90°~-45°',
        'Swivel Range': '+90°~-90°',
        'Screen Rotation': '+180°~-180°',
        'Arm Full Extension': '450mm (17.7")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~80mm, Grommet: 10~45mm',
        'Quick Release VESA Plate': 'No',
        'USB Port': 'No',
        'Cable Management': 'Yes',
        'Accessory Kit Package': 'Normal/Ziplock Polybag, Compartment Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Mekanik Yay Monitör Kolu',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Siyah',
        'Boyutlar': '937x111x585mm (36.9"x4.4"x23")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '2',
        'Taşıma Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'VESA Uyumluluğu': '75x75, 100x100',
        'Eğim (Tilt) Aralığı': '+90°~-45°',
        'Dönüş (Swivel) Aralığı': '+90°~-90°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'Kol Tam Uzatma': '450mm (17.7")',
        'Kurulum Tipi': 'Kıskaç (Clamp), Delikli Yüzey (Grommet)',
        'Önerilen Masaüstü Kalınlığı': 'Kelepçe: 10~80mm, Grommet: 10~45mm',
        'Hızlı Çıkarma VESA Plakası': 'Hayır',
        'USB Portu': 'Yok',
        'Kablo Yönetimi': 'Var',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba, Bölmeli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/24374sli_Gaming%20Arms%20%202.png'
    ]
  },
  {
    id: 'g-ma3',
    name: 'MA48-S1732-BLK',
    model: 'MA48-S1732-BLK',
    displayName: {
      en: 'Single Monitor\nPole-Mounted Spring-Assisted\nMonitor Arm',
      tr: 'Tek Monitör\nDirek Montajlı Yay Destekli\nMonitör Kolu'
    },
    category: 'Gaming Monitor Arms',
    type: 'gaming',
    shortDesc: {
      en: 'For most 17"-32" Monitors',
      tr: '17"-32" Monitörler için'
    },
    fullDesc: {
      en: 'With its sturdy construction and effortless adjustment, the MA48-S1732-BLK Single Monitor Pole-Mounted Spring-Assisted Monitor Arm holds the monitor securely above the work surface, freeing up valuable desk space. Ideal for organizing and optimizing any home or office work area. The quick-release VESA plate makes installing or removing the monitor quick and easy. Built-in cable management keeps wires hidden and aligned for a clean look. Best of all, the MA48-S1732-BLK is competitively priced to add sales and profits for your business.',
      tr: 'Sağlam yapısı ve zahmetsiz ayarlamasıyla MA48-S1732-BLK Tek Monitör Direk Montajlı Yay Destekli Monitör Kolu, monitörü çalışma yüzeyinin üzerinde güvenli bir şekilde tutarak değerli masa alanını serbest bırakır. Ev veya ofis çalışma alanlarını düzenlemek ve optimize etmek için idealdir. Hızlı çıkarma VESA plakası, monitörün takılmasını veya çıkarılmasını hızlı ve kolay hale getirir. Dahili kablo yönetimi, temiz bir görünüm için kabloları gizli ve hizalı tutar. En önemlisi, MA48-S1732-BLK işletmeniz için satış ve kâr eklemek üzere rekabetçi bir fiyata sahiptir.'
    },
    features: [
      { en: 'Spring-Assisted Mechanism: allows to easily move up and down', tr: 'Yay Destekli Mekanizma: kolayca yukarı ve aşağı hareket ettirir' },
      { en: '360° Rotary VESA Plate: for more viewing experience', tr: '360° Döner VESA Plakası: daha iyi izleme deneyimi için' },
      { en: 'Built-in Cable Management: for an organized and neat workspace', tr: 'Dahili Kablo Yönetimi: düzenli ve temiz bir çalışma alanı için' },
      { en: 'Space-Saving Design: free up and gain additional desktop work space', tr: 'Alan Tasarrufu Sağlayan Tasarım: ek masaüstü çalışma alanı kazanın' }
    ],
    specs: {
      en: {
        'Product Category': 'Mechanical Spring Monitor Arm',
        'Rank': 'Standard',
        'Material': 'Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black',
        'Dimensions': '114x538x715mm (4.5"x21.2"x28.1")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '1',
        'Weight Capacity (per screen)': '1~9kg (2.2~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+35°~-35°',
        'Swivel Range': '+90°~-90°',
        'Screen Rotation': '+180°~-180°',
        'Arm Full Extension': '468mm (18.4")',
        'Pole Height': '308mm (12.1")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~85mm, Grommet: 10~40mm',
        'Quick Release VESA Plate': 'Yes',
        'USB Port': 'No',
        'Multi-Media Port': 'No',
        'Cable Management': 'Yes',
        'Accessory Kit Package': 'Normal/Ziplock Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Mekanik Yay Monitör Kolu',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Siyah',
        'Boyutlar': '114x538x715mm (4.5"x21.2"x28.1")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '1',
        'Taşıma Kapasitesi (ekran başına)': '1~9kg (2.2~19.8lbs)',
        'VESA Uyumluluğu': '75x75, 100x100',
        'Eğim (Tilt) Aralığı': '+35°~-35°',
        'Dönüş (Swivel) Aralığı': '+90°~-90°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'Kol Tam Uzatma': '468mm (18.4")',
        'Direk Yüksekliği': '308mm (12.1")',
        'Kurulum Tipi': 'Kıskaç (Clamp), Delikli Yüzey (Grommet)',
        'Önerilen Masaüstü Kalınlığı': 'Kelepçe: 10~85mm, Grommet: 10~40mm',
        'Hızlı Çıkarma VESA Plakası': 'Evet',
        'USB Portu': 'Yok',
        'Multi-Medya Portu': 'Yok',
        'Kablo Yönetimi': 'Var',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/zge07rvk_GAMING%20%201%20-%201%20%20%20MA48-S1732-BLK.jpg'
    ]
  },
  {
    id: 'g-ma4',
    name: 'MA48-D1732-BLK',
    model: 'MA48-D1732-BLK',
    displayName: {
      en: 'Dual Monitor\nPole-Mounted Spring-Assisted\nMonitor Arm',
      tr: 'Çift Monitör\nDirek Montajlı Yay Destekli\nMonitör Kolu'
    },
    category: 'Gaming Monitor Arms',
    type: 'gaming',
    shortDesc: {
      en: 'For most 17"-32" Monitors',
      tr: '17"-32" Monitörler için'
    },
    fullDesc: {
      en: 'With its sturdy construction and effortless adjustment, the MA48-D1732-BLK Dual Monitor Pole-Mounted Spring-Assisted Monitor Arm holds the monitor securely above the work surface, freeing up valuable desk space. Ideal for organizing and optimizing any home or office work area. The quick-release VESA plate makes installing or removing the monitor quick and easy. Built-in cable management keeps wires hidden and aligned for a clean look. Best of all, the MA48-D1732-BLK is competitively priced to add sales and profits for your business.',
      tr: 'Sağlam yapısı ve zahmetsiz ayarlamasıyla MA48-D1732-BLK Çift Monitör Direk Montajlı Yay Destekli Monitör Kolu, monitörleri çalışma yüzeyinin üzerinde güvenli bir şekilde tutarak değerli masa alanını serbest bırakır. Ev veya ofis çalışma alanlarını düzenlemek ve optimize etmek için idealdir. Hızlı çıkarma VESA plakası, monitörlerin takılmasını veya çıkarılmasını hızlı ve kolay hale getirir. Dahili kablo yönetimi, temiz bir görünüm için kabloları gizli ve hizalı tutar. En önemlisi, MA48-D1732-BLK işletmeniz için satış ve kâr eklemek üzere rekabetçi bir fiyata sahiptir.'
    },
    features: [
      { en: 'Spring-Assisted Mechanism: allows to easily move up and down', tr: 'Yay Destekli Mekanizma: kolayca yukarı ve aşağı hareket ettirir' },
      { en: '360° Rotary VESA Plate: for more viewing experience', tr: '360° Döner VESA Plakası: daha iyi izleme deneyimi için' },
      { en: 'Built-in Cable Management: for an organized and neat workspace', tr: 'Dahili Kablo Yönetimi: düzenli ve temiz bir çalışma alanı için' },
      { en: 'Space-Saving Design: free up and gain additional desktop work space', tr: 'Alan Tasarrufu Sağlayan Tasarım: ek masaüstü çalışma alanı kazanın' }
    ],
    specs: {
      en: {
        'Product Category': 'Mechanical Spring Monitor Arm',
        'Rank': 'Standard',
        'Material': 'Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black',
        'Dimensions': '940x123x715mm (37"x4.8"x28.1")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '2',
        'Weight Capacity (per screen)': '1~9kg (2.2~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+35°~-35°',
        'Swivel Range': '+90°~-90°',
        'Screen Rotation': '+180°~-180°',
        'Arm Full Extension': '468mm (18.4")',
        'Pole Height': '308mm (12.1")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~85mm, Grommet: 10~40mm',
        'Quick Release VESA Plate': 'Yes',
        'USB Port': 'No',
        'Multi-Media Port': 'No',
        'Cable Management': 'Yes',
        'Accessory Kit Package': 'Normal/Ziplock Polybag, Compartment Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Mekanik Yay Monitör Kolu',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Siyah',
        'Boyutlar': '940x123x715mm (37"x4.8"x28.1")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '2',
        'Taşıma Kapasitesi (ekran başına)': '1~9kg (2.2~19.8lbs)',
        'VESA Uyumluluğu': '75x75, 100x100',
        'Eğim (Tilt) Aralığı': '+35°~-35°',
        'Dönüş (Swivel) Aralığı': '+90°~-90°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'Kol Tam Uzatma': '468mm (18.4")',
        'Direk Yüksekliği': '308mm (12.1")',
        'Kurulum Tipi': 'Kıskaç (Clamp), Delikli Yüzey (Grommet)',
        'Önerilen Masaüstü Kalınlığı': 'Kelepçe: 10~85mm, Grommet: 10~40mm',
        'Hızlı Çıkarma VESA Plakası': 'Evet',
        'USB Portu': 'Yok',
        'Multi-Medya Portu': 'Yok',
        'Kablo Yönetimi': 'Var',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba, Bölmeli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/oe51sqad_grok-image-cbb5e676-098e-4764-a85d-4246e5b989c7.png'
    ]
  },
  // RGB Desk Mount Monitor Arms (Gaming Only)
  {
    id: 'g-ma7',
    name: 'MA119-RGBS12-LW',
    model: 'MA119-RGBS12-LW',
    displayName: {
      en: 'EVERGLOW Gas Spring Monitor Arm\nwith RGB Lighting',
      tr: 'EVERGLOW RGB Aydınlatmalı\nGaz Yaylı Monitör Kolu'
    },
    category: 'Gaming Monitor Arms',
    type: 'gaming',
    shortDesc: {
      en: 'Lights up your zone with full illumination.',
      tr: 'Tam aydınlatma ile bölgenizi aydınlatır.'
    },
    fullDesc: {
      en: 'Meet the uniqueness of the MA119-RGBS12-LW\u2014 the entire lower arm is surrounded by RGB lighting, effectively amplifying your gaming vibe. Switch the lighting effects easily with the built-in button at the base. Furthermore, MA119-RGBS12-LW also supports lighting control via Windows 11\'s "Dynamic Lighting". The gas spring tension mechanism ensures smooth, stable positioning, while the rotation stop keeps the arm from colliding with walls or partitions. The quick-release VESA plate makes setup fast and hassle-free.',
      tr: 'MA119-RGBS12-LW\u2019nun benzersizliğiyle tanışın\u2014 alt kolun tamamı RGB aydınlatma ile çevrilidir ve oyun atmosferinizi etkili bir şekilde güçlendirir. Tabandaki dahili düğme ile aydınlatma efektlerini kolayca değiştirin. Ayrıca MA119-RGBS12-LW, Windows 11\'in "Dynamic Lighting" özelliği ile aydınlatma kontrolünü de destekler. Gaz yaylı gerginlik mekanizması pürüzsüz ve kararlı konumlandırma sağlarken, dönme durdurucu kolun duvarlara veya bölmelere çarpmasını önler. Hızlı çıkarmalı VESA plakası kurulumu hızlı ve zahmetsiz hale getirir.'
    },
    features: [
      { en: 'Diverse RGB Lighting Effects: the full lower arm is surrounded by RGB lighting to maximize gameplay ambience', tr: 'Çeşitli RGB Aydınlatma Efektleri: oyun atmosferini en üst düzeye çıkarmak için alt kolun tamamı RGB aydınlatma ile çevrilidir' },
      { en: 'Supports Windows 11 "Dynamic Lighting" control', tr: 'Windows 11 "Dynamic Lighting" kontrolünü destekler' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gerginlik Mekanizması: mükemmel ağırlık ayarları için' },
      { en: 'Quick-Release VESA Plate: for easy installation and removal', tr: 'Hızlı Çıkarmalı VESA Plakası: kolay kurulum ve çıkarma için' },
      { en: 'Built-in Switch Button: for easy controlling lighting modes', tr: 'Dahili Anahtar Düğmesi: aydınlatma modlarını kolayca kontrol etmek için' },
      { en: 'Wide Range of Movements: allows screen tilting, swiveling, rotation and height adjustments for optimum viewing', tr: 'Geniş Hareket Aralığı: optimum görüntüleme için ekran eğme, döndürme, rotasyon ve yükseklik ayarları sağlar' },
      { en: 'Rotation Stop: prevents monitor arm from swinging into screens or walls', tr: 'Dönme Durdurucu: monitör kolunun ekranlara veya duvarlara çarpmasını önler' }
    ],
    specs: {
      en: {
        'Product Category': 'Gas Spring Monitor Arm',
        'Rank': 'Standard',
        'Material': 'Aluminum, Steel, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Finer Texture Black, Finer Texture Black & Space Grey',
        'Dimensions': '120x552x660mm (4.7"x21.7"x26")',
        'Fit Screen Size': '17"-40"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '1',
        'Weight Capacity (per screen)': '2~12kg (4.4~26.4lbs)',
        'Weight Capacity for Curved Screen (per screen)': '2~12kg (4.4~26.4lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+80\u00b0~-45\u00b0',
        'Swivel Range': '+90\u00b0~-90\u00b0',
        'Screen Rotation': '+180\u00b0~-180\u00b0',
        'Arm Full Extension': '422mm (16.6")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~75mm, Grommet: 10~80mm (Clamp: 0.39"~3", Grommet: 0.39"~3.1")',
        'Quick Release VESA Plate': 'Yes',
        'USB Port': 'No',
        'Cable Management': 'Yes'
      },
      tr: {
        'Ürün Kategorisi': 'Gaz Yaylı Monitör Kolu',
        'Sınıf': 'Standart',
        'Malzeme': 'Alüminyum, Çelik, Plastik',
        'Yüzey İşlemi': 'Toz Boya',
        'Renk': 'İnce Dokulu Siyah, İnce Dokulu Siyah & Uzay Grisi',
        'Boyutlar': '120x552x660mm (4.7"x21.7"x26")',
        'Uygun Ekran Boyutu': '17"-40"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '1',
        'Ağırlık Kapasitesi (ekran başına)': '2~12kg (4.4~26.4lbs)',
        'Kavisli Ekran Ağırlık Kapasitesi (ekran başına)': '2~12kg (4.4~26.4lbs)',
        'VESA Uyumlu': '75x75, 100x100',
        'Eğim Aralığı': '+80\u00b0~-45\u00b0',
        'Dönme Aralığı': '+90\u00b0~-90\u00b0',
        'Ekran Rotasyonu': '+180\u00b0~-180\u00b0',
        'Kol Tam Uzanma': '422mm (16.6")',
        'Kurulum': 'Kelepçe, Conta',
        'Önerilen Masa Kalınlığı': 'Kelepçe: 10~75mm, Conta: 10~80mm (Kelepçe: 0.39"~3", Conta: 0.39"~3.1")',
        'Hızlı Çıkarma VESA Plakası': 'Evet',
        'USB Bağlantı Noktası': 'Hayır',
        'Kablo Yönetimi': 'Evet'
      }
    },
    images: [
      'https://images.unsplash.com/photo-1593640408182-31c70c8268f5?crop=entropy&cs=srgb&fm=jpg&q=85'
    ],
    imagesTr: [
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/p3miq6cq_LDT119-C012LW%20%20%20%20%20Color%20Variation%20%20%202T.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/mzvsgcd9_LDT119-C012LW%20%20%20%205T.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/djzzkrwe_LDT119-C012LW%20%20%20%207T.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/vsnwzlno_LDT119-C012LW%20%20%20%208T.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/gfvc8y4s_LDT119-C012LW%20%20%20%204T.PNG'
    ]
  },
  {
    id: 'g-ma8',
    name: 'MA119-RGBD12-LW',
    model: 'MA119-RGBD12-LW',
    displayName: {
      en: 'EVERGLOW Dual-Screen Gas Spring\nMonitor Arm with RGB Lighting',
      tr: 'EVERGLOW Çift Ekran Gaz Yaylı\nRGB Aydınlatmalı Monitör Kolu'
    },
    category: 'Gaming Monitor Arms',
    type: 'gaming',
    shortDesc: {
      en: 'Lights up your zone with full illumination.',
      tr: 'Tam aydınlatma ile bölgenizi aydınlatır.'
    },
    fullDesc: {
      en: 'Meet the uniqueness of the MA119-RGBD12-LW \u2014 the entire lower arms are surrounded by RGB lighting, effectively amplifying your gaming vibe. Switch the lighting effects easily with the built-in button at the base. Furthermore, MA119-RGBD12-LW also supports lighting control via Windows 11\'s "Dynamic Lighting". The gas spring tension mechanism ensures smooth, stable positioning, while the rotation stop keeps the arms from colliding with walls or partitions. The quick-release VESA plates make setup fast and hassle-free.',
      tr: 'MA119-RGBD12-LW\u2019nun benzersizliğiyle tanışın \u2014 alt kolların tamamı RGB aydınlatma ile çevrilidir ve oyun atmosferinizi etkili bir şekilde güçlendirir. Tabandaki dahili düğme ile aydınlatma efektlerini kolayca değiştirin. Ayrıca MA119-RGBD12-LW, Windows 11\'in "Dynamic Lighting" özelliği ile aydınlatma kontrolünü de destekler. Gaz yaylı gerginlik mekanizması pürüzsüz ve kararlı konumlandırma sağlarken, dönme durdurucu kolların duvarlara veya bölmelere çarpmasını önler. Hızlı çıkarmalı VESA plakaları kurulumu hızlı ve zahmetsiz hale getirir.'
    },
    features: [
      { en: 'Diverse RGB Lighting Effects: the full lower arm is surrounded by RGB lighting to maximize gameplay ambience', tr: 'Çeşitli RGB Aydınlatma Efektleri: oyun atmosferini en üst düzeye çıkarmak için alt kolun tamamı RGB aydınlatma ile çevrilidir' },
      { en: 'Supports Windows 11 "Dynamic Lighting" control', tr: 'Windows 11 "Dynamic Lighting" kontrolünü destekler' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gerginlik Mekanizması: mükemmel ağırlık ayarları için' },
      { en: 'Quick-Release VESA Plate: for easy installation and removal', tr: 'Hızlı Çıkarmalı VESA Plakası: kolay kurulum ve çıkarma için' },
      { en: 'Built-in Switch Button: for easy controlling lighting modes', tr: 'Dahili Anahtar Düğmesi: aydınlatma modlarını kolayca kontrol etmek için' },
      { en: 'Wide Range of Movements: allows screen tilting, swiveling, rotation and height adjustments for optimum viewing', tr: 'Geniş Hareket Aralığı: optimum görüntüleme için ekran eğme, döndürme, rotasyon ve yükseklik ayarları sağlar' },
      { en: 'Rotation Stop: prevents monitor arm from swinging into screens or walls', tr: 'Dönme Durdurucu: monitör kolunun ekranlara veya duvarlara çarpmasını önler' }
    ],
    specs: {
      en: {
        'Product Category': 'Gas Spring Monitor Arm',
        'Rank': 'Standard',
        'Material': 'Aluminum, Steel, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Finer Texture Black, Finer Texture Black & Space Grey',
        'Dimensions': '1033x130x660mm (40.7"x5.1"x26")',
        'Fit Screen Size': '17"-35"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '2',
        'Weight Capacity (per screen)': '2~12kg (4.4~26.4lbs)',
        'Weight Capacity for Curved Screen (per screen)': '2~12kg (4.4~26.4lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+80\u00b0~-45\u00b0',
        'Swivel Range': '+90\u00b0~-90\u00b0',
        'Screen Rotation': '+180\u00b0~-180\u00b0',
        'Arm Full Extension': '422mm (16.6")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~75mm, Grommet: 10~80mm (Clamp: 0.39"~3", Grommet: 0.39"~3.1")',
        'Quick Release VESA Plate': 'Yes',
        'USB Port': 'No',
        'Cable Management': 'Yes'
      },
      tr: {
        'Ürün Kategorisi': 'Gaz Yaylı Monitör Kolu',
        'Sınıf': 'Standart',
        'Malzeme': 'Alüminyum, Çelik, Plastik',
        'Yüzey İşlemi': 'Toz Boya',
        'Renk': 'İnce Dokulu Siyah, İnce Dokulu Siyah & Uzay Grisi',
        'Boyutlar': '1033x130x660mm (40.7"x5.1"x26")',
        'Uygun Ekran Boyutu': '17"-35"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '2',
        'Ağırlık Kapasitesi (ekran başına)': '2~12kg (4.4~26.4lbs)',
        'Kavisli Ekran Ağırlık Kapasitesi (ekran başına)': '2~12kg (4.4~26.4lbs)',
        'VESA Uyumlu': '75x75, 100x100',
        'Eğim Aralığı': '+80\u00b0~-45\u00b0',
        'Dönme Aralığı': '+90\u00b0~-90\u00b0',
        'Ekran Rotasyonu': '+180\u00b0~-180\u00b0',
        'Kol Tam Uzanma': '422mm (16.6")',
        'Kurulum': 'Kelepçe, Conta',
        'Önerilen Masa Kalınlığı': 'Kelepçe: 10~75mm, Conta: 10~80mm (Kelepçe: 0.39"~3", Conta: 0.39"~3.1")',
        'Hızlı Çıkarma VESA Plakası': 'Evet',
        'USB Bağlantı Noktası': 'Hayır',
        'Kablo Yönetimi': 'Evet'
      }
    },
    images: [
      'https://images.unsplash.com/photo-1593640408182-31c70c8268f5?crop=entropy&cs=srgb&fm=jpg&q=85'
    ]
  },
  {
    id: 'g-acc1',
    name: 'PS5-TW-04',
    model: 'PS5-TW-04',
    displayName: {
      en: 'Pole-Mounted Holder for\nPS5 and Switch',
      tr: 'PS5 ve Switch için\nDirek Montajlı Tutucu'
    },
    category: 'Gaming Accessories',
    type: 'gaming',
    shortDesc: {
      en: 'Essential gaming console organizer',
      tr: 'Vazgeçilmez oyun konsolu düzenleyici'
    },
    fullDesc: {
      en: 'Keep your gaming setup organized with the PS5-TW-04. This pole-mounted holder keeps your PlayStation 5 and Nintendo Switch within easy reach while freeing up valuable desk space. Includes holders for controllers and headsets.',
      tr: 'PS5-TW-04 ile oyun kurulumunuzu düzenli tutun. Bu direk montajlı tutucu, PlayStation 5 ve Nintendo Switch\'inizi kolay erişilebilir konumda tutarken değerli masa alanını serbest bırakır. Kumanda ve kulaklık tutucuları dahildir.'
    },
    features: [
      { en: 'PS5 & Switch compatible', tr: 'PS5 ve Switch uyumlu' },
      { en: 'Controller holders included', tr: 'Kumanda tutucuları dahil' },
      { en: 'Headset hook', tr: 'Kulaklık kancası' },
      { en: 'Space-saving design', tr: 'Alan tasarrufu sağlayan tasarım' }
    ],
    specs: {
      en: {
        'Compatibility': 'PS5, Nintendo Switch',
        'Mount Type': 'Pole-Mounted',
        'Weight Capacity': '5kg',
        'Material': 'Steel, Plastic, Silicone'
      },
      tr: {
        'Uyumluluk': 'PS5, Nintendo Switch',
        'Montaj Tipi': 'Direk Montajlı',
        'Taşıma Kapasitesi': '5kg',
        'Malzeme': 'Çelik, Plastik, Silikon'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/s5pkdhdx_PS5%201.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/n52pfw3e_PS5%202.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/tw210pua_PS5%203.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/2y20m49o_PS5%204.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/bna2mfkb_PS5%205.PNG'
    ]
  }
];

export const officeProducts = [
  {
    id: 'o1',
    name: 'MA13-S1732-BLK',
    model: 'MA13-S1732-BLK',
    displayName: {
      en: 'Economic Spring-Supported Monitor Arm',
      tr: 'Yay Destekli\nMonitör Kolu'
    },
    category: 'Monitor Arms',
    type: 'office',
    shortDesc: {
      en: 'Affordable single monitor arm with spring support',
      tr: 'Yay destekli ekonomik tek monitör kolu'
    },
    fullDesc: {
      en: 'The MA13-S1732-BLK offers excellent value with smooth spring-supported adjustment. Perfect for home offices and workstations requiring flexible monitor positioning.',
      tr: 'MA13-S1732-BLK, pürüzsüz yay destekli ayarlama ile mükemmel değer sunar. Esnek monitör konumlandırması gerektiren ev ofisleri ve iş istasyonları için idealdir.'
    },
    features: [
      { en: 'Keyhole Pattern: allows for easy installation', tr: 'Anahtar Deliği Deseni: kolay kurulum sağlar' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gergi Mekanizması: mükemmel ağırlık ayarı için' },
      { en: 'Two Mounting Options: both desk clamp and grommet are included', tr: 'İki Montaj Seçeneği: hem masa kelepçesi hem de grommet dahildir' },
      { en: 'Built-in Cable Management: for an organized and neat workspace', tr: 'Dahili Kablo Yönetimi: düzenli ve temiz bir çalışma alanı için' }
    ],
    specs: {
      en: {
        'Product Category': 'Mechanical Spring Monitor Arm',
        'Rank': 'Standard',
        'Material': 'Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black',
        'Dimensions': '117x478x585mm (4.6"x18.8"x23")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '1',
        'Weight Capacity (per screen)': '2~9kg (4.4~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+90°~-45°',
        'Swivel Range': '+90°~-90°',
        'Screen Rotation': '+180°~-180°',
        'Arm Full Extension': '450mm (17.7")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~80mm, Grommet: 10~45mm',
        'Quick Release VESA Plate': 'No',
        'USB Port': 'No',
        'Cable Management': 'Yes',
        'Accessory Kit Package': 'Normal/Ziplock Polybag, Compartment Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Mekanik Yay Monitör Kolu',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Siyah',
        'Boyutlar': '117x478x585mm (4.6"x18.8"x23")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '1',
        'Taşıma Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'VESA Uyumluluğu': '75x75, 100x100',
        'Eğim (Tilt) Aralığı': '+90°~-45°',
        'Dönüş (Swivel) Aralığı': '+90°~-90°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'Kol Tam Uzatma': '450mm (17.7")',
        'Kurulum Tipi': 'Kıskaç (Clamp), Delikli Yüzey (Grommet)',
        'Önerilen Masaüstü Kalınlığı': 'Kelepçe: 10~80mm, Grommet: 10~45mm',
        'Hızlı Çıkarma VESA Plakası': 'Yok',
        'USB Portu': 'Yok',
        'Kablo Yönetimi': 'Var',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba, Bölmeli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-home-1/artifacts/wkrq3409_grok-image-a535b453-57d4-4c51-a1a4-fe19a6760ffd%20%281%29.png'
    ],
    featureImages: [
      {
        url: 'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/b16tenav_Cable%20Manag%20%201.png',
        title: { en: 'Cable Management', tr: 'Kablo Yönetimi' },
        description: { en: 'for an organized and clean look', tr: 'düzenli ve temiz bir görünüm için' }
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/6iw662rd_Spring%20tension%20%20%20%201.png',
        title: { en: 'Spring Tension Mechanism', tr: 'Yay Gergi Mekanizması' },
        description: { en: 'ensures perfect weight balance for monitors', tr: 'monitörler için mükemmel ağırlık dengesi sağlar' }
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/23qw3n02_VEsa%20Plate%20%20%20%20%201.png',
        title: { en: 'VESA Plate with Keyhole Slots', tr: 'Anahtar Delikli VESA Plakası' },
        description: { en: 'for quick installation and removal', tr: 'hızlı kurulum ve çıkarma için' }
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/cn2ua03d_Quick%20Release%20%20%201.png',
        title: { en: 'Quick-Release Joint', tr: 'Kolay Montaj' },
        description: { en: 'allows easy assembly and compact package for e-commerce', tr: 'kolay montaj ve e-ticaret için kompakt paketleme sağlar' }
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/jb1dkxws_Motion%20%20%201.png',
        title: { en: 'Full Range of Movement', tr: 'Tam Hareket Aralığı' },
        description: { en: 'for the optimal viewing position', tr: 'optimal izleme pozisyonu için' }
      },
      {
        url: 'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/q8g7a0h2_Dimension%20%20%20%20%201.png',
        title: { en: 'Technical Dimensions', tr: 'Teknik Boyutlar' },
        description: { en: 'detailed measurements for precise installation', tr: 'hassas kurulum için detaylı ölçüler' }
      }
    ]
  },
  {
    id: 'o1b',
    name: 'MA13-D1732-BLK',
    model: 'MA13-D1732-BLK',
    displayName: {
      en: 'Economic Dual Screen Spring-Supported Monitor Arm',
      tr: 'Çift Ekran Yay Destekli Monitör Kolu'
    },
    category: 'Monitor Arms',
    type: 'office',
    shortDesc: {
      en: 'Affordable dual monitor arm with spring support',
      tr: 'Yay destekli ekonomik çift monitör kolu'
    },
    fullDesc: {
      en: 'The MA13-D1732-BLK provides dual monitor support at an excellent price point. Spring-supported arms ensure smooth positioning for both screens.',
      tr: 'MA13-D1732-BLK, mükemmel fiyat noktasında çift monitör desteği sağlar. Yay destekli kollar, her iki ekran için pürüzsüz konumlandırma sağlar.'
    },
    features: [
      { en: 'Dual monitor support', tr: 'Çift monitör desteği' },
      { en: 'Spring-supported smooth adjustment', tr: 'Yay destekli pürüzsüz ayarlama' },
      { en: 'Supports monitors 17"-32"', tr: '17"-32" monitör desteği' },
      { en: 'VESA 75x75 and 100x100 compatible', tr: 'VESA 75x75 ve 100x100 uyumlu' },
      { en: 'Independent arm movement', tr: 'Bağımsız kol hareketi' }
    ],
    specs: {
      en: {
        'Model': 'MA13-D1732-BLK',
        'Screen Size': '17" - 32" (each)',
        'Max Weight': '9kg per arm',
        'VESA': '75x75mm, 100x100mm',
        'Tilt': '+90° / -45°',
        'Swivel': '180°',
        'Rotation': '360°',
        'Color': 'Black'
      },
      tr: {
        'Model': 'MA13-D1732-BLK',
        'Ekran Boyutu': '17" - 32" (her biri)',
        'Maks. Ağırlık': 'Kol başına 9kg',
        'VESA': '75x75mm, 100x100mm',
        'Eğim': '+90° / -45°',
        'Dönüş': '180°',
        'Rotasyon': '360°',
        'Renk': 'Siyah'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/anfud7yb_Home%20%26%20Office%20.png'
    ],
    gamingCardImage: 'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/24374sli_Gaming%20Arms%20%202.png'
  },
  {
    id: 'o1c',
    name: 'MA48-S1732-BLK',
    model: 'MA48-S1732-BLK',
    displayName: {
      en: 'Single Monitor\nPole-Mounted Spring-Assisted\nMonitor Arm',
      tr: 'Tek Monitör\nDirek Montajlı Yay Destekli\nMonitör Kolu'
    },
    category: 'Monitor Arms',
    type: 'office',
    shortDesc: {
      en: 'For most 17"-32" Monitors',
      tr: '17"-32" Monitörler için'
    },
    fullDesc: {
      en: 'With its sturdy construction and effortless adjustment, the MA48-S1732-BLK Single Monitor Pole-Mounted Spring-Assisted Monitor Arm holds the monitor securely above the work surface, freeing up valuable desk space. Ideal for organizing and optimizing any home or office work area. The quick-release VESA plate makes installing or removing the monitor quick and easy. Built-in cable management keeps wires hidden and aligned for a clean look. Best of all, the MA48-S1732-BLK is competitively priced to add sales and profits for your business.',
      tr: 'Sağlam yapısı ve zahmetsiz ayarlamasıyla MA48-S1732-BLK Tek Monitör Direk Montajlı Yay Destekli Monitör Kolu, monitörü çalışma yüzeyinin üzerinde güvenli bir şekilde tutarak değerli masa alanını serbest bırakır. Ev veya ofis çalışma alanlarını düzenlemek ve optimize etmek için idealdir. Hızlı çıkarma VESA plakası, monitörün takılmasını veya çıkarılmasını hızlı ve kolay hale getirir. Dahili kablo yönetimi, temiz bir görünüm için kabloları gizli ve hizalı tutar. En önemlisi, MA48-S1732-BLK işletmeniz için satış ve kâr eklemek üzere rekabetçi bir fiyata sahiptir.'
    },
    features: [
      { en: 'Spring-Assisted Mechanism: allows to easily move up and down', tr: 'Yay Destekli Mekanizma: kolayca yukarı ve aşağı hareket ettirir' },
      { en: '360° Rotary VESA Plate: for more viewing experience', tr: '360° Döner VESA Plakası: daha iyi izleme deneyimi için' },
      { en: 'Built-in Cable Management: for an organized and neat workspace', tr: 'Dahili Kablo Yönetimi: düzenli ve temiz bir çalışma alanı için' },
      { en: 'Space-Saving Design: free up and gain additional desktop work space', tr: 'Alan Tasarrufu Sağlayan Tasarım: ek masaüstü çalışma alanı kazanın' }
    ],
    specs: {
      en: {
        'Product Category': 'Mechanical Spring Monitor Arm',
        'Rank': 'Standard',
        'Material': 'Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black',
        'Dimensions': '114x538x715mm (4.5"x21.2"x28.1")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '1',
        'Weight Capacity (per screen)': '1~9kg (2.2~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+35°~-35°',
        'Swivel Range': '+90°~-90°',
        'Screen Rotation': '+180°~-180°',
        'Arm Full Extension': '468mm (18.4")',
        'Pole Height': '308mm (12.1")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~85mm, Grommet: 10~40mm',
        'Quick Release VESA Plate': 'Yes',
        'USB Port': 'No',
        'Multi-Media Port': 'No',
        'Cable Management': 'Yes',
        'Accessory Kit Package': 'Normal/Ziplock Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Mekanik Yay Monitör Kolu',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Siyah',
        'Boyutlar': '114x538x715mm (4.5"x21.2"x28.1")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '1',
        'Taşıma Kapasitesi (ekran başına)': '1~9kg (2.2~19.8lbs)',
        'VESA Uyumluluğu': '75x75, 100x100',
        'Eğim (Tilt) Aralığı': '+35°~-35°',
        'Dönüş (Swivel) Aralığı': '+90°~-90°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'Kol Tam Uzatma': '468mm (18.4")',
        'Direk Yüksekliği': '308mm (12.1")',
        'Kurulum Tipi': 'Kıskaç (Clamp), Delikli Yüzey (Grommet)',
        'Önerilen Masaüstü Kalınlığı': 'Kelepçe: 10~85mm, Grommet: 10~40mm',
        'Hızlı Çıkarma VESA Plakası': 'Evet',
        'USB Portu': 'Yok',
        'Multi-Medya Portu': 'Yok',
        'Kablo Yönetimi': 'Var',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/osezrkj6_MA48-S1732-BLK%20%20%20%20%20-%206-2.png',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/ao0scxpj_MA48-S1732-BLK%20%20%20%20%20-%204.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/h6lwo927_MA48-S1732-BLK%20%20%20%20%20-%205.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/bw1mb0k5_MA48-S1732-BLK%20%20%20%20%20-%202.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/aiiqaprh_MA48-S1732-BLK%20%20%20%20%20-%203.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/evrfs03t_MA48-S1732-BLK%20%20%20%20%20-%201.PNG'
    ]
  },
  {
    id: 'o1d',
    name: 'MA48-D1732-BLK',
    model: 'MA48-D1732-BLK',
    displayName: {
      en: 'Dual Monitor\nPole-Mounted Spring-Assisted\nMonitor Arm',
      tr: 'Çift Monitör\nDirek Montajlı Yay Destekli\nMonitör Kolu'
    },
    category: 'Monitor Arms',
    type: 'office',
    shortDesc: {
      en: 'For most 17"-32" Monitors',
      tr: '17"-32" Monitörler için'
    },
    fullDesc: {
      en: 'With its sturdy construction and effortless adjustment, the MA48-D1732-BLK Dual Monitor Pole-Mounted Spring-Assisted Monitor Arm holds the monitor securely above the work surface, freeing up valuable desk space. Ideal for organizing and optimizing any home or office work area. The quick-release VESA plate makes installing or removing the monitor quick and easy. Built-in cable management keeps wires hidden and aligned for a clean look. Best of all, the MA48-D1732-BLK is competitively priced to add sales and profits for your business.',
      tr: 'Sağlam yapısı ve zahmetsiz ayarlamasıyla MA48-D1732-BLK Çift Monitör Direk Montajlı Yay Destekli Monitör Kolu, monitörleri çalışma yüzeyinin üzerinde güvenli bir şekilde tutarak değerli masa alanını serbest bırakır. Ev veya ofis çalışma alanlarını düzenlemek ve optimize etmek için idealdir. Hızlı çıkarma VESA plakası, monitörlerin takılmasını veya çıkarılmasını hızlı ve kolay hale getirir. Dahili kablo yönetimi, temiz bir görünüm için kabloları gizli ve hizalı tutar. En önemlisi, MA48-D1732-BLK işletmeniz için satış ve kâr eklemek üzere rekabetçi bir fiyata sahiptir.'
    },
    features: [
      { en: 'Spring-Assisted Mechanism: allows to easily move up and down', tr: 'Yay Destekli Mekanizma: kolayca yukarı ve aşağı hareket ettirir' },
      { en: '360° Rotary VESA Plate: for more viewing experience', tr: '360° Döner VESA Plakası: daha iyi izleme deneyimi için' },
      { en: 'Built-in Cable Management: for an organized and neat workspace', tr: 'Dahili Kablo Yönetimi: düzenli ve temiz bir çalışma alanı için' },
      { en: 'Space-Saving Design: free up and gain additional desktop work space', tr: 'Alan Tasarrufu Sağlayan Tasarım: ek masaüstü çalışma alanı kazanın' }
    ],
    specs: {
      en: {
        'Product Category': 'Mechanical Spring Monitor Arm',
        'Rank': 'Standard',
        'Material': 'Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black',
        'Dimensions': '940x123x715mm (37"x4.8"x28.1")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '2',
        'Weight Capacity (per screen)': '1~9kg (2.2~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+35°~-35°',
        'Swivel Range': '+90°~-90°',
        'Screen Rotation': '+180°~-180°',
        'Arm Full Extension': '468mm (18.4")',
        'Pole Height': '308mm (12.1")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~85mm, Grommet: 10~40mm',
        'Quick Release VESA Plate': 'Yes',
        'USB Port': 'No',
        'Multi-Media Port': 'No',
        'Cable Management': 'Yes',
        'Accessory Kit Package': 'Normal/Ziplock Polybag, Compartment Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Mekanik Yay Monitör Kolu',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Siyah',
        'Boyutlar': '940x123x715mm (37"x4.8"x28.1")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '2',
        'Taşıma Kapasitesi (ekran başına)': '1~9kg (2.2~19.8lbs)',
        'VESA Uyumluluğu': '75x75, 100x100',
        'Eğim (Tilt) Aralığı': '+35°~-35°',
        'Dönüş (Swivel) Aralığı': '+90°~-90°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'Kol Tam Uzatma': '468mm (18.4")',
        'Direk Yüksekliği': '308mm (12.1")',
        'Kurulum Tipi': 'Kıskaç (Clamp), Delikli Yüzey (Grommet)',
        'Önerilen Masaüstü Kalınlığı': 'Kelepçe: 10~85mm, Grommet: 10~40mm',
        'Hızlı Çıkarma VESA Plakası': 'Evet',
        'USB Portu': 'Yok',
        'Multi-Medya Portu': 'Yok',
        'Kablo Yönetimi': 'Var',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba, Bölmeli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/oe51sqad_grok-image-cbb5e676-098e-4764-a85d-4246e5b989c7.png'
    ]
  },
  // New Office Desk Mount Monitor Arms
  {
    id: 'o-ma5',
    name: 'MA112-S1732-BLK',
    model: 'MA112-S1732-BLK',
    displayName: {
      en: 'Super Economy Mechanical Spring Monitor Arm\nDesigned for precision and comfort',
      tr: 'Mekanik Yaylı Monitör Kolu\nHassasiyet ve konfor için tasarlandı'
    },
    category: 'Monitor Arms',
    type: 'office',
    shortDesc: {
      en: 'Designed for precision and comfort',
      tr: 'Hassasiyet ve konfor için tasarlandı'
    },
    fullDesc: {
      en: 'Experience seamless flexibility with our MA112-S1732-BLK. The multi-angle positioning and a spring tension mechanism makes screen adjustment effortless, the keyhole-patterned VESA plate and detachable joint make setup simple while minimizing packaging size. To fit different desktops, both grommet and clamp-on options are offered.',
      tr: 'MA112-S1732-BLK ile kesintisiz esneklik deneyimi yaşayın. Çok açılı konumlandırma ve yay gerginlik mekanizması ekran ayarını zahmetsiz hale getirir, anahtar deliği desenli VESA plakası ve ayrılabilir mafsal kurulumu basitleştirirken paketleme boyutunu en aza indirir. Farklı masaüstlerine uyum sağlamak için hem delikli yüzey hem de kelepçe seçenekleri sunulmaktadır.'
    },
    features: [
      { en: 'Wide Range of Movements: allows screen tilting, swiveling, rotation and height adjustments for optimum viewing', tr: 'Geniş Hareket Aralığı: optimum izleme için ekran eğme, döndürme, rotasyon ve yükseklik ayarlarına olanak tanır' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gerginlik Mekanizması: mükemmel ağırlık ayarları için' },
      { en: 'Keyhole Pattern: allows for easy installation', tr: 'Anahtar Deliği Deseni: kolay kurulum sağlar' },
      { en: 'Two Mounting Options: both desk clamp and grommet are included', tr: 'İki Montaj Seçeneği: hem masa kelepçesi hem de delikli yüzey montajı dahildir' }
    ],
    specs: {
      en: {
        'Product Category': 'Mechanical Spring Monitor Arm',
        'Rank': 'Economy',
        'Material': 'Steel, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black, Fine Texture White',
        'Dimensions': '117x487x569mm (4.6"x19.2"x22.4")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '1',
        'Weight Capacity (per screen)': '2~9kg (4.4~19.8lbs)',
        'Weight Capacity for Curved Screen': '2~9kg (4.4~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+90°~-45°',
        'Swivel Range': '+90°~-90°',
        'Screen Rotation': '+180°~-180°',
        'Arm Full Extension': '451mm (17.8")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~80mm, Grommet: 10~40mm',
        'Quick Release VESA Plate': 'No',
        'USB Port': 'No',
        'Cable Management': 'Yes',
        'Direction Indicator': 'Yes',
        'Accessory Kit Package': 'Normal/Ziplock Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Mekanik Yay Monitör Kolu',
        'Segment': 'Ekonomi',
        'Malzeme': 'Çelik, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Siyah, İnce Dokulu Beyaz',
        'Boyutlar': '117x487x569mm (4.6"x19.2"x22.4")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '1',
        'Taşıma Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'Kavisli Ekran Taşıma Kapasitesi': '2~9kg (4.4~19.8lbs)',
        'VESA Uyumluluğu': '75x75, 100x100',
        'Eğim (Tilt) Aralığı': '+90°~-45°',
        'Dönüş (Swivel) Aralığı': '+90°~-90°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'Kol Tam Uzatma': '451mm (17.8")',
        'Kurulum Tipi': 'Kıskaç (Clamp), Delikli Yüzey (Grommet)',
        'Önerilen Masaüstü Kalınlığı': 'Kelepçe: 10~80mm, Grommet: 10~40mm',
        'Hızlı Çıkarma VESA Plakası': 'Hayır',
        'USB Portu': 'Yok',
        'Kablo Yönetimi': 'Var',
        'Yön Göstergesi': 'Evet',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/0do87zme_CARD.JPG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/vj8s4jhl_MA112-S1732-BLK%20%20%20%20%201.JPG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/wru2ezh3_MA112-S1732-BLK%20%20%20%20%202.JPG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/amyfxg5z_VEsa%20Plate%20%20%20%20%201.png',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/asmqyeid_Quick%20Release%20%20%201.png',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/kyf3p590_Spring%20tension%20%20%20%201.png',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/a4yvr221_MA112-S1732-BLK%20%20%20%20%203.png'
    ],
    imagesTr: [
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/0do87zme_CARD.JPG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/377yafc1_MA112-S1732-BLK%20%20%20%20%201%20T%20.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/0d3q3w3t_MA112-S1732-BLK%20%20%20%20%202%20T.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/amyfxg5z_VEsa%20Plate%20%20%20%20%201.png',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/asmqyeid_Quick%20Release%20%20%201.png',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/kyf3p590_Spring%20tension%20%20%20%201.png',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/a4yvr221_MA112-S1732-BLK%20%20%20%20%203.png'
    ],
    cardImage: 'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/0do87zme_CARD.JPG',
    cardImageTr: 'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/0do87zme_CARD.JPG'
  },
  {
    id: 'o-ma6',
    name: 'MA112-D1732-BLK',
    model: 'MA112-D1732-BLK',
    displayName: {
      en: 'Super Economy Mechanical Spring\nDual-Screen Monitor Arm',
      tr: 'Mekanik Yaylı\nÇift Ekran Monitör Kolu'
    },
    category: 'Monitor Arms',
    type: 'office',
    shortDesc: {
      en: 'Designed for precision and comfort.',
      tr: 'Hassasiyet ve konfor için tasarlandı.'
    },
    fullDesc: {
      en: 'Experience enhanced flexibility with our MA112-D1732-BLK. The dual-screen setup maximizes desktop space with a seamless screen position. The multi-angle positioning and a spring tension mechanism makes screen adjustment effortless, the keyhole-patterned VESA plate and detachable joint make setup simple while minimizing packaging size. To fit different desktops, both grommet and clamp-on options are offered.',
      tr: 'MA112-D1732-BLK ile gelişmiş esneklik deneyimleyin. Çift ekran kurulumu, kusursuz ekran konumlandırmasıyla masaüstü alanını en üst düzeye çıkarır. Çok açılı konumlandırma ve yay gerginlik mekanizması ekran ayarını zahmetsiz hale getirirken, anahtar deliği desenli VESA plakası ve çıkarılabilir eklem, ambalaj boyutunu en aza indirirken kurulumu basitleştirir. Farklı masaüstlerine uyum sağlamak için hem conta hem de kelepçe seçenekleri sunulmaktadır.'
    },
    features: [
      { en: 'Wide Range of Movements: allows screen tilting, swiveling, rotation and height adjustments for optimum viewing', tr: 'Geniş Hareket Aralığı: optimum görüntüleme için ekran eğme, döndürme, rotasyon ve yükseklik ayarları sağlar' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gerginlik Mekanizması: mükemmel ağırlık ayarları için' },
      { en: 'Keyhole Pattern: allows for easy installation', tr: 'Anahtar Deliği Deseni: kolay kurulum sağlar' },
      { en: 'Two Mounting Options: both desk clamp and grommet are included', tr: 'İki Montaj Seçeneği: hem masa kelepçesi hem de conta dahildir' }
    ],
    specs: {
      en: {
        'Product Category': 'Mechanical Spring Monitor Arm',
        'Rank': 'Economy',
        'Material': 'Steel, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black, Fine Texture White',
        'Dimensions': '950x105x565mm (37.4"x4.1"x22.2")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '2',
        'Weight Capacity (per screen)': '2~9kg (4.4~19.8lbs)',
        'Weight Capacity for Curved Screen (per screen)': '2~9kg (4.4~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+90\u00b0~-45\u00b0',
        'Swivel Range': '+90\u00b0~-90\u00b0',
        'Screen Rotation': '+180\u00b0~-180\u00b0',
        'Arm Full Extension': '451mm (17.8")',
        'Installation': 'Clamp, Grommet',
        'Suggested Desktop Thickness': 'Clamp: 10~80mm, Grommet: 10~40mm (Clamp: 0.39"~3.1", Grommet: 0.39"~1.6")',
        'Quick Release VESA Plate': 'No',
        'USB Port': 'No',
        'Cable Management': 'Yes',
        'Direction Indicator': 'Yes',
        'Accessory Kit Package': 'Normal/Ziplock Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Mekanik Yaylı Monitör Kolu',
        'Sınıf': 'Ekonomi',
        'Malzeme': 'Çelik, Plastik',
        'Yüzey İşlemi': 'Toz Boya',
        'Renk': 'Mat Siyah, İnce Dokulu Beyaz',
        'Boyutlar': '950x105x565mm (37.4"x4.1"x22.2")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '2',
        'Ağırlık Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'Kavisli Ekran Ağırlık Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'VESA Uyumlu': '75x75, 100x100',
        'Eğim Aralığı': '+90\u00b0~-45\u00b0',
        'Dönme Aralığı': '+90\u00b0~-90\u00b0',
        'Ekran Rotasyonu': '+180\u00b0~-180\u00b0',
        'Kol Tam Uzanma': '451mm (17.8")',
        'Kurulum': 'Kelepçe, Conta',
        'Önerilen Masa Kalınlığı': 'Kelepçe: 10~80mm, Conta: 10~40mm (Kelepçe: 0.39"~3.1", Conta: 0.39"~1.6")',
        'Hızlı Çıkarma VESA Plakası': 'Hayır',
        'USB Bağlantı Noktası': 'Hayır',
        'Kablo Yönetimi': 'Evet',
        'Yön Göstergesi': 'Evet',
        'Aksesuar Kiti Paketi': 'Normal/Fermuarlı Poşet'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/eb88dyoc_MA112-D1732-BLK%20%20%20%20CARD%20.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/hdny3a4e_MA112-D1732-BLK%20%20%20%201%20.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/b955t8qs_MA112-D1732-BLK%20%20%20%202%20.PNG'
    ],
    imagesTr: [
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/w9jmai8y_MA112-D1732-BLK%20%20%20%20CARD%20T%20.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/hdny3a4e_MA112-D1732-BLK%20%20%20%201%20.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/b955t8qs_MA112-D1732-BLK%20%20%20%202%20.PNG'
    ],
    cardImage: 'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/eb88dyoc_MA112-D1732-BLK%20%20%20%20CARD%20.PNG',
    cardImageTr: 'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/w9jmai8y_MA112-D1732-BLK%20%20%20%20CARD%20T%20.PNG'
  },
  // Wall Mount Monitor Arms (Office)
  {
    id: 'o-ma9',
    name: 'MDA113-S1732-BLK',
    model: 'MDA113-S1732-BLK',
    displayName: {
      en: 'Affordable Gas Spring\nWall-Mounted Monitor Arm',
      tr: 'Gaz Yaylı\nDuvar Montajlı Monitör Kolu'
    },
    category: 'Monitor Arms',
    type: 'office',
    shortDesc: {
      en: 'Value you need, versatility you want.',
      tr: 'İhtiyacınız olan değer, istediğiniz çok yönlülük.'
    },
    fullDesc: {
      en: 'Built to deliver outstanding value without compromising performance, the MDA113-S1732-BLK features multi-angle adjustability and a spring tension mechanism for smooth, effortless positioning. The keyhole-patterned VESA plate and detachable joint simplify installation and reduce packaging size\u2014making the series more efficient and cost-friendly for e-commerce.',
      tr: 'Performanstan ödün vermeden üstün değer sunmak için tasarlanan MDA113-S1732-BLK, pürüzsüz ve zahmetsiz konumlandırma için çok açılı ayarlanabilirlik ve yay gerginlik mekanizmasına sahiptir. Anahtar deliği desenli VESA plakası ve çıkarılabilir eklem, kurulumu basitleştirir ve ambalaj boyutunu azaltır\u2014bu da seriyi e-ticaret için daha verimli ve maliyet dostu hale getirir.'
    },
    features: [
      { en: 'Wide Range of Movements: allows screen tilting, swiveling, rotation and height adjustments for optimum viewing', tr: 'Geniş Hareket Aralığı: optimum görüntüleme için ekran eğme, döndürme, rotasyon ve yükseklik ayarları sağlar' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gerginlik Mekanizması: mükemmel ağırlık ayarları için' },
      { en: 'Quick-Release VESA Plate: for easy installation and removal', tr: 'Hızlı Çıkarmalı VESA Plakası: kolay kurulum ve çıkarma için' },
      { en: 'Cable Management: keeps everything organized', tr: 'Kablo Yönetimi: her şeyi düzenli tutar' }
    ],
    specs: {
      en: {
        'Product Category': 'Gas Spring Monitor Arm',
        'Rank': 'Economy',
        'Material': 'Steel, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black, Fine Texture White',
        'Dimensions': '116x535x551mm (4.6"x21.1"x21.7")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '1',
        'Weight Capacity (per screen)': '2~9kg (4.4~19.8lbs)',
        'Weight Capacity for Curved Screen (per screen)': '2~9kg (4.4~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+80\u00b0~-45\u00b0',
        'Swivel Range': '+90\u00b0~-90\u00b0',
        'Screen Rotation': '+180\u00b0~-180\u00b0',
        'Arm Full Extension': '496mm (19.5")',
        'Installation': 'Wall Mounted',
        'Quick Release VESA Plate': 'No',
        'USB Port': 'No',
        'Cable Management': 'Yes'
      },
      tr: {
        'Ürün Kategorisi': 'Gaz Yaylı Monitör Kolu',
        'Sınıf': 'Ekonomi',
        'Malzeme': 'Çelik, Plastik',
        'Yüzey İşlemi': 'Toz Boya',
        'Renk': 'Mat Siyah, İnce Dokulu Beyaz',
        'Boyutlar': '116x535x551mm (4.6"x21.1"x21.7")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '1',
        'Ağırlık Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'Kavisli Ekran Ağırlık Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'VESA Uyumlu': '75x75, 100x100',
        'Eğim Aralığı': '+80\u00b0~-45\u00b0',
        'Dönme Aralığı': '+90\u00b0~-90\u00b0',
        'Ekran Rotasyonu': '+180\u00b0~-180\u00b0',
        'Kol Tam Uzanma': '496mm (19.5")',
        'Kurulum': 'Duvar Montajı',
        'Hızlı Çıkarma VESA Plakası': 'Hayır',
        'USB Bağlantı Noktası': 'Hayır',
        'Kablo Yönetimi': 'Evet'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/gllnkqdp_MDA113-S1732-BLK%20%20%20%20%20%20Card.PNG',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/9im0nxgq_MDA113-S1732-BLK%20%20%20%20%20%20%20%201.jpg',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/mtj1qa2f_MDA113-S1732-BLK%20%20%20%20%20%20%20%202.jpg',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/9jk9mvdf_MDA113-S1732-BLK%20%20%20%20%20%204.jpg',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/dynojb7x_MDA113-S1732-BLK%20%20%20%20%20%205.PNG'
    ],
    cardImage: 'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/gllnkqdp_MDA113-S1732-BLK%20%20%20%20%20%20Card.PNG',
    cardImageTr: 'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/gllnkqdp_MDA113-S1732-BLK%20%20%20%20%20%20Card.PNG'
  },
  {
    id: 'o-ma10',
    name: 'MDA113-D1732-BLK',
    model: 'MDA113-D1732-BLK',
    displayName: {
      en: 'Affordable Dual-Screen Wall-Mounted\nGas Spring Monitor Arm',
      tr: 'Çift Ekran Duvar Montajlı\nGaz Yaylı Monitör Kolu'
    },
    category: 'Monitor Arms',
    type: 'office',
    shortDesc: {
      en: 'Value you need, versatility you want.',
      tr: 'İhtiyacınız olan değer, istediğiniz çok yönlülük.'
    },
    fullDesc: {
      en: 'Built to deliver outstanding value without compromising performance, the MDA113-D1732-BLK features multi-angle adjustability and a spring tension mechanism for smooth, effortless positioning. The keyhole-patterned VESA plate and detachable joint simplify installation and reduce packaging size\u2014making the series more efficient and cost-friendly for e-commerce.',
      tr: 'Performanstan ödün vermeden üstün değer sunmak için tasarlanan MDA113-D1732-BLK, pürüzsüz ve zahmetsiz konumlandırma için çok açılı ayarlanabilirlik ve yay gerginlik mekanizmasına sahiptir. Anahtar deliği desenli VESA plakası ve çıkarılabilir eklem, kurulumu basitleştirir ve ambalaj boyutunu azaltır\u2014bu da seriyi e-ticaret için daha verimli ve maliyet dostu hale getirir.'
    },
    features: [
      { en: 'Wide Range of Movements: allows screen tilting, swiveling, rotation and height adjustments for optimum viewing', tr: 'Geniş Hareket Aralığı: optimum görüntüleme için ekran eğme, döndürme, rotasyon ve yükseklik ayarları sağlar' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gerginlik Mekanizması: mükemmel ağırlık ayarları için' },
      { en: 'Quick-Release VESA Plate: for easy installation and removal', tr: 'Hızlı Çıkarmalı VESA Plakası: kolay kurulum ve çıkarma için' },
      { en: 'Cable Management: keeps everything organized', tr: 'Kablo Yönetimi: her şeyi düzenli tutar' }
    ],
    specs: {
      en: {
        'Product Category': 'Gas Spring Monitor Arm',
        'Rank': 'Economy',
        'Material': 'Steel, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte Black, Fine Texture White',
        'Dimensions': '1061x95x548mm (41.8"x3.7"x21.6")',
        'Fit Screen Size': '17"-32"',
        'Fit Curved Monitor': 'Yes',
        'Screen Quantity': '2',
        'Weight Capacity (per screen)': '2~9kg (4.4~19.8lbs)',
        'Weight Capacity for Curved Screen (per screen)': '2~9kg (4.4~19.8lbs)',
        'VESA Compatible': '75x75, 100x100',
        'Tilt Range': '+80\u00b0~-45\u00b0',
        'Swivel Range': '+90\u00b0~-90\u00b0',
        'Screen Rotation': '+180\u00b0~-180\u00b0',
        'Arm Full Extension': '496mm (19.5")',
        'Installation': 'Wall Mounted',
        'Quick Release VESA Plate': 'No',
        'USB Port': 'No',
        'Cable Management': 'Yes'
      },
      tr: {
        'Ürün Kategorisi': 'Gaz Yaylı Monitör Kolu',
        'Sınıf': 'Ekonomi',
        'Malzeme': 'Çelik, Plastik',
        'Yüzey İşlemi': 'Toz Boya',
        'Renk': 'Mat Siyah, İnce Dokulu Beyaz',
        'Boyutlar': '1061x95x548mm (41.8"x3.7"x21.6")',
        'Uygun Ekran Boyutu': '17"-32"',
        'Kavisli Monitör Uyumu': 'Evet',
        'Ekran Adedi': '2',
        'Ağırlık Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'Kavisli Ekran Ağırlık Kapasitesi (ekran başına)': '2~9kg (4.4~19.8lbs)',
        'VESA Uyumlu': '75x75, 100x100',
        'Eğim Aralığı': '+80\u00b0~-45\u00b0',
        'Dönme Aralığı': '+90\u00b0~-90\u00b0',
        'Ekran Rotasyonu': '+180\u00b0~-180\u00b0',
        'Kol Tam Uzanma': '496mm (19.5")',
        'Kurulum': 'Duvar Montajı',
        'Hızlı Çıkarma VESA Plakası': 'Hayır',
        'USB Bağlantı Noktası': 'Hayır',
        'Kablo Yönetimi': 'Evet'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/8lwu80ja_MDA113-D1732-BLK.png',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/smwflgma_MDA113-D1732-BLK%20%20%203.png',
      'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/mpbefced_MDA113-D1732-BLK%20%20%20%20%20%20%20%20%202.png'
    ],
    cardImage: 'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/smwflgma_MDA113-D1732-BLK%20%20%203.png',
    cardImageTr: 'https://customer-assets.emergentagent.com/job_ab355cfb-fe6f-414d-8d49-60dee9eea1cc/artifacts/smwflgma_MDA113-D1732-BLK%20%20%203.png'
  },
  // TV Stands / TV Standları
  {
    id: 'tv1',
    name: 'TVA12-4565-B3A',
    model: 'TVA12-4565-B3A',
    displayName: {
      en: 'More Than a Stand\nAn Eye-Catching Piece of Home Décor',
      tr: 'Bir Standdan Daha Fazlası\nEv Dekorasyonunuzun Göz Alıcı Bir Parçası'
    },
    category: 'TV Stands',
    type: 'office',
    shortDesc: {
      en: 'An Eye-Catching Piece of Home Décor',
      tr: 'Ev Dekorasyonunuzun Göz Alıcı Bir Parçası'
    },
    fullDesc: {
      en: 'TVA12-4565-B3A TV Floor Stand is an innovative design that uses quality metal and traditional hardwood that fits beautifully into any décor. Sleek and elegant and user-friendly as well. Simplicity and convenience are at the heart of the stand assembly. Packaged for ecommerce or retail sales, the Easel Studio TV Floor stand is the next generation of stand and the ideal choice for home or office TV display. A smart cable management system and safety kit included.',
      tr: 'TVA12-4565-B3A TV Yer Standı, kaliteli metal ve geleneksel sert ahşap kullanan, her dekorasyona güzelce uyan yenilikçi bir tasarımdır. Şık, zarif ve kullanıcı dostudur. Basitlik ve kolaylık, stand montajının kalbinde yer alır. E-ticaret veya perakende satış için paketlenmiş olan Şövale Stüdyo TV Yer Standı, yeni nesil stand ve ev veya ofis TV gösterimi için ideal seçimdir. Akıllı kablo yönetim sistemi ve güvenlik kiti dahildir.'
    },
    features: [
      { en: 'Special Swivel Ability: supports flexible viewing angle and enough space for maintenance', tr: 'Özel Döndürme Özelliği: esnek izleme açısı ve bakım için yeterli alan sağlar' },
      { en: 'Snap Lock: for easier and quick TV assembly', tr: 'Kilit Mekanizması: daha kolay ve hızlı TV montajı için' },
      { en: 'Cable Management: keeps everything organized', tr: 'Kablo Yönetimi: her şeyi düzenli tutar' },
      { en: 'Rubber Pads: prevent slippery and floor-scratching', tr: 'Kauçuk Pedler: kayma ve zemin çizilmesini önler' },
      { en: 'Safety Kits Included: all hardwares to prevent accidental tipping', tr: 'Güvenlik Kiti Dahil: kazara devrilmeyi önleyen tüm donanımlar' }
    ],
    specs: {
      en: {
        'Product Category': 'Studio TV Floor Stand',
        'Rank': 'Standard',
        'Material': 'Steel, Aluminum, Plastic, Beech',
        'Surface Finish': 'Powder Coating',
        'Dimensions': '1385x880x420mm (54.5"x34.6"x16.5")',
        'Fit Screen Size': '45"-65"',
        'VESA Compatible': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400, 600x400',
        'Max. Mounting Hole': '600x400',
        'Weight Capacity': '32kg (70.4lbs)',
        'Strength Tested': '3 Times Approved',
        'Swivel Range': '+180°~-180°',
        'Cable Management': 'Yes',
        'Color': 'Matte Black & Walnut, Matte White & Beech',
        'Accessories': 'TV Anti-Tip Strap',
        'Accessory Kit Package': 'Compartment Polybag',
        'Certification': 'RoHS',
        'Solid Wood Included': 'Yes',
        'Silk Screen': 'Can be silkscreen printed'
      },
      tr: {
        'Ürün Kategorisi': 'Stüdyo TV Yer Standı',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Alüminyum, Plastik, Kayın',
        'Yüzey Kaplaması': 'Toz Boya',
        'Boyutlar': '1385x880x420mm (54.5"x34.6"x16.5")',
        'Uygun Ekran Boyutu': '45"-65"',
        'VESA Uyumlu': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400, 600x400',
        'Maks. Montaj Deliği': '600x400',
        'Taşıma Kapasitesi': '32kg (70.4lbs)',
        'Dayanıklılık Testi': '3 Kat Onaylı',
        'Dönüş Aralığı': '+180°~-180°',
        'Kablo Yönetimi': 'Var',
        'Renk': 'Mat Siyah & Ceviz, Mat Beyaz & Kayın',
        'Aksesuarlar': 'TV Devrilme Önleyici Kayış',
        'Aksesuar Paketi': 'Bölmeli Polietilen Torba',
        'Sertifika': 'RoHS',
        'Masif Ahşap Dahil': 'Evet',
        'Serigrafi': 'Serigrafi baskı yapılabilir'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/es21m6lt_GROK%20TVA12-4565-B3A.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/kndggtjq_TVA12-4565-B3A%20%201.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/8otbfeu3_TVA12-4565-B3A%20%202.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/yj2uesut_TVA12-4565-B3A%20%203.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/qtk7i0x1_TVA12-4565-B3A%20%204.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/ro7mo3y0_TVA12-4565-B3A%20%205.png'
    ],
    imagesTr: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/es21m6lt_GROK%20TVA12-4565-B3A.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/kndggtjq_TVA12-4565-B3A%20%201.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/8otbfeu3_TVA12-4565-B3A%20%202.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/yj2uesut_TVA12-4565-B3A%20%203.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/wwk1z4ls_TVA12-4565-B3A%20%204T.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/ro7mo3y0_TVA12-4565-B3A%20%205.png'
    ]
  },
  {
    id: 'tv2',
    name: 'TVA12-6590-D4A',
    model: 'TVA12-6590-D4A',
    displayName: {
      en: 'Heavy-Duty Eiffel TV Stand',
      tr: 'Yüksek Taşıma Kapasiteli Eiffel TV Standı'
    },
    category: 'TV Stands',
    type: 'office',
    shortDesc: {
      en: 'The ultimate TV mount for big screens and heavy loads',
      tr: 'Büyük ekranlar ve ağır yükler için en iyi TV standı'
    },
    fullDesc: {
      en: 'Introducing the TVA12-6590-D4A, the ultimate TV mount for big screens and heavy loads! Specifically designed for large TVs from 65 to 90 inches and capable of holding up to 60kg, we have upgraded the leg material to iron for extra durability and increased the horizontal dimension and pole height without changing the overall design. This stand is the perfect choice for those who want to secure their TV without sacrificing style or functionality. The Heavy-Duty Eiffel TV Stand is the new go-to solution for a safe and secure TV viewing experience.',
      tr: 'TVA12-6590-D4A ile tanışın - büyük ekranlar ve ağır yükler için en iyi TV standı! 65 ila 90 inç arası büyük TV\'ler için özel olarak tasarlanan ve 60 kg\'a kadar taşıma kapasitesine sahip bu stantta, ekstra dayanıklılık için ayak malzemesi demire yükseltilmiş, genel tasarımı değiştirmeden yatay boyut ve direk yüksekliği artırılmıştır. Bu stand, stil veya işlevsellikten ödün vermeden TV\'lerini güvence altına almak isteyenler için mükemmel bir seçimdir. Yüksek Taşıma Kapasiteli Eiffel TV Standı, güvenli bir TV izleme deneyimi için yeni tercih edilen çözümdür.'
    },
    features: [
      { en: 'Heavy-Duty steel construction holds the heaviest TVs with confidence', tr: 'Yüksek taşıma kapasiteli çelik yapı, en ağır TV\'leri güvenle taşır' },
      { en: 'Increased size and height for greater load capacity', tr: 'Daha yüksek taşıma kapasitesi için artırılmış boyut ve yükseklik' },
      { en: 'Easy Assembly: Installation is as easy as 1-2-3', tr: 'Kolay Montaj: Kurulum 1-2-3 kadar kolay' }
    ],
    specs: {
      en: {
        'Product Category': 'Studio TV Floor Stand',
        'Rank': 'Premium',
        'Material': 'Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Dimensions': '1570x1100x500mm (61.8"x43.3"x19.7")',
        'Fit Screen Size': '65"-90"',
        'VESA Compatible': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400, 600x400, 800x400, 850x400, 900x400, 800x600, 850x600, 900x600',
        'Max. Mounting Hole': '900x600',
        'Weight Capacity': '60kg (132lbs)',
        'Strength Tested': '3 Times Approved',
        'Direction Indicator': 'Yes',
        'Cable Management': 'Yes',
        'Color': 'Matte Black, Matte White',
        'Accessories': 'TV Anti-Tip Strap',
        'Accessory Kit Package': 'Normal/Ziplock Polybag, Compartment Polybag',
        'Solid Wood Included': 'No',
        'Silk Screen': 'Can be silkscreen printed'
      },
      tr: {
        'Ürün Kategorisi': 'Stüdyo TV Yer Standı',
        'Segment': 'Premium',
        'Malzeme': 'Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Boyutlar': '1570x1100x500mm (61.8"x43.3"x19.7")',
        'Uygun Ekran Boyutu': '65"-90"',
        'VESA Uyumlu': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400, 600x400, 800x400, 850x400, 900x400, 800x600, 850x600, 900x600',
        'Maks. Montaj Deliği': '900x600',
        'Taşıma Kapasitesi': '60kg (132lbs)',
        'Dayanıklılık Testi': '3 Kat Onaylı',
        'Yön Göstergesi': 'Evet',
        'Kablo Yönetimi': 'Var',
        'Renk': 'Mat Siyah, Mat Beyaz',
        'Aksesuarlar': 'TV Devrilme Önleyici Kayış',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba, Bölmeli Polietilen Torba',
        'Masif Ahşap Dahil': 'Hayır',
        'Serigrafi': 'Serigrafi baskı yapılabilir'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/bduku17g_GROK%20%20TVA12-6590-D4A.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/wlmms8b5_TVA12-6590-D4A%20%20%201.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/arforrj8_TVA12-6590-D4A%20%20%202.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/z76wsrhf_TVA12-6590-D4A%20%20%203.png'
    ],
    imagesTr: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/bduku17g_GROK%20%20TVA12-6590-D4A.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/d8h0skgn_TVA12-6590-D4A%20%20%201T.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/npbhzmw0_TVA12-6590-D4A%20%20%202T.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/z76wsrhf_TVA12-6590-D4A%20%20%203.png'
    ]
  },
  {
    id: 'tv3',
    name: 'TVA35-4565-B3AF1',
    model: 'TVA35-4565-B3AF1',
    displayName: {
      en: 'Solid Wood TV Floor Stand\nAdd Warmth Through Accents',
      tr: 'Masif Ahşap TV Yer Standı\nAksan Detaylarıyla Sıcaklık Katın'
    },
    category: 'TV Stands',
    type: 'office',
    shortDesc: {
      en: 'Add Warmth Through Accents',
      tr: 'Aksan Detaylarıyla Sıcaklık Katın'
    },
    fullDesc: {
      en: 'The TVA35-4565-B3AF1 Solid Wood TV Floor Stand adds a welcoming and cozy feeling to any room. Clean lines and a hint of rustic styling deliver an authentic, hand-forged look. The magnetic branding badge lid on the front offers a pleasing focal point for the brand logo, and the magnetic cover on the back leg helps to access and hide cables. As with all-natural materials, this solid wood stand creates a classic and poetic ambiance.',
      tr: 'TVA35-4565-B3AF1 Masif Ahşap TV Yer Standı, herhangi bir odaya sıcak ve samimi bir his katar. Temiz çizgiler ve hafif rustik stil, otantik, el yapımı bir görünüm sunar. Ön taraftaki manyetik marka rozeti kapağı, marka logosu için hoş bir odak noktası sunarken, arka ayaktaki manyetik kapak kabloları gizlemeye ve erişmeye yardımcı olur. Tüm doğal malzemelerde olduğu gibi, bu masif ahşap stand klasik ve şiirsel bir ambiyans yaratır.'
    },
    features: [
      { en: 'Magnetic Cover and Branding Badge: covers hardware and a place for brand logos', tr: 'Manyetik Kapak ve Marka Rozeti: donanımı kapatır ve marka logoları için yer sağlar' },
      { en: 'Solid Wood Construction: offers sufficient support', tr: 'Masif Ahşap Yapı: yeterli destek sağlar' },
      { en: 'Snap Lock: for easier and quick TV assembly', tr: 'Kilit Mekanizması: daha kolay ve hızlı TV montajı için' },
      { en: 'Magnetic Cable Management Cover: easy to access and hide cables', tr: 'Manyetik Kablo Yönetim Kapağı: kabloları kolayca gizleyin ve erişin' }
    ],
    specs: {
      en: {
        'Product Category': 'Studio TV Floor Stand',
        'Rank': 'Premium',
        'Material': 'Beech, Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Dimensions': '765x540x1335mm (30.1"x21.3"x52.6")',
        'Fit Screen Size': '45"-65"',
        'VESA Compatible': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400',
        'Max. Mounting Hole': '405x400',
        'Weight Capacity': '40kg (88lbs)',
        'Strength Tested': '3 Times Approved',
        'Swivel Range': '±45°',
        'Direction Indicator': 'Yes',
        'Cable Management': 'Yes',
        'Color': 'Matte Black & Walnut, Matte White & Beech',
        'Accessories': 'TV Anti-Tip Strap',
        'Accessory Kit Package': 'Normal/Ziplock Polybag, Compartment Polybag',
        'Solid Wood Included': 'Yes',
        'Silk Screen': 'Can be silkscreen printed'
      },
      tr: {
        'Ürün Kategorisi': 'Stüdyo TV Yer Standı',
        'Segment': 'Premium',
        'Malzeme': 'Kayın, Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Boyutlar': '765x540x1335mm (30.1"x21.3"x52.6")',
        'Uygun Ekran Boyutu': '45"-65"',
        'VESA Uyumlu': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400',
        'Maks. Montaj Deliği': '405x400',
        'Taşıma Kapasitesi': '40kg (88lbs)',
        'Dayanıklılık Testi': '3 Kat Onaylı',
        'Dönüş Aralığı': '±45°',
        'Yön Göstergesi': 'Evet',
        'Kablo Yönetimi': 'Var',
        'Renk': 'Mat Siyah & Ceviz, Mat Beyaz & Kayın',
        'Aksesuarlar': 'TV Devrilme Önleyici Kayış',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba, Bölmeli Polietilen Torba',
        'Masif Ahşap Dahil': 'Evet',
        'Serigrafi': 'Serigrafi baskı yapılabilir'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/fxylxbgy_GROK%20%20%20TVA35-4565-B3AF1%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/cwbiid8m_TVA35-4565-B3AF1%20%20%20%201.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/da0sedid_TVA35-4565-B3AF1%20%20%20%202.png'
    ],
    imagesTr: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/fxylxbgy_GROK%20%20%20TVA35-4565-B3AF1%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/n80d0yze_TVA35-4565-B3AF1%20%20%20%201T.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/34pd12fu_TVA35-4565-B3AF1%20%20%20%202T.png'
    ]
  },
  {
    id: 'tv4',
    name: 'TVA36-4365-B4AF2',
    model: 'TVA36-4365-B4AF2',
    displayName: {
      en: 'Danish Style TV Floor Stand\nwith Storage Shelf',
      tr: 'Danimarka Stili TV Yer Standı\nDepolama Raflı'
    },
    category: 'TV Stands',
    type: 'office',
    shortDesc: {
      en: 'Classic Danish design with storage shelf',
      tr: 'Depolama raflı klasik Danimarka tasarımı'
    },
    fullDesc: {
      en: 'The classic TVA36-4365-B4AF2 TV stand references the tradition of Danish design through its simple frame and subtle details. The TV mounts to unique adjustable back rails that save both space and assembly time. Sleek details and delightful expression shows its unique character. Infusing the room with warmth and an airy design, this TV stand represents the modern expression of long-lasting aesthetics.',
      tr: 'Klasik TVA36-4365-B4AF2 TV standı, sade çerçevesi ve ince detaylarıyla Danimarka tasarım geleneğine atıfta bulunur. TV, hem yerden hem de montaj süresinden tasarruf sağlayan benzersiz ayarlanabilir arka raylara monte edilir. Şık detaylar ve keyifli ifade, benzersiz karakterini ortaya koyar. Odaya sıcaklık ve havadar bir tasarım katan bu TV standı, uzun ömürlü estetiğin modern ifadesini temsil eder.'
    },
    features: [
      { en: 'Additional Support Shelf: for equipment or materials', tr: 'Ek Destek Rafı: ekipman veya malzemeler için' },
      { en: 'Distance to the wall is closer: design for a smaller footprint', tr: 'Duvara mesafe daha yakın: daha küçük alan için tasarım' },
      { en: 'Cable Clip: routes cables to reduce clutter for a clean look and more organized place', tr: 'Kablo Klipsi: temiz bir görünüm ve daha düzenli bir alan için kabloları yönlendirir' },
      { en: 'Soft EVA Foam Pads: protect furniture from scratches or scuffs', tr: 'Yumuşak EVA Köpük Pedler: mobilyaları çizik ve aşınmalardan korur' },
      { en: 'Unique TV Mounting System: provide a more elegant look', tr: 'Benzersiz TV Montaj Sistemi: daha zarif bir görünüm sağlar' },
      { en: 'Soft cushion on metal part: protect the lower edge of TV', tr: 'Metal kısımdaki yumuşak yastık: TV\'nin alt kenarını korur' }
    ],
    specs: {
      en: {
        'Product Category': 'Studio TV Floor Stand',
        'Rank': 'Standard',
        'Material': 'Steel, Plastic, Beech, Particle Board & Melamine',
        'Surface Finish': 'Powder Coating',
        'Dimensions': '721x370x1258mm (28.4"x14.6"x49.5")',
        'Fit Screen Size': '43"-65"',
        'VESA Compatible': '100x100, 200x100, 200x200, 300x200, 400x200, 300x300, 400x300, 400x400',
        'Max. Mounting Hole': '400x400',
        'Weight Capacity': '40kg (88lbs)',
        'Strength Tested': '4 Times Approved',
        'Direction Indicator': 'No',
        'Cable Management': 'Yes',
        'Color': 'Matte Black & Walnut, Matte White & Beech',
        'Weight Capacity (Storage Cabinet)': '10kg (22lbs)',
        'Accessories': 'TV Anti-Tip Strap',
        'Accessory Kit Package': 'Compartment Polybag',
        'Solid Wood Included': 'Yes'
      },
      tr: {
        'Ürün Kategorisi': 'Stüdyo TV Yer Standı',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Plastik, Kayın, Sunta & Melamin',
        'Yüzey Kaplaması': 'Toz Boya',
        'Boyutlar': '721x370x1258mm (28.4"x14.6"x49.5")',
        'Uygun Ekran Boyutu': '43"-65"',
        'VESA Uyumlu': '100x100, 200x100, 200x200, 300x200, 400x200, 300x300, 400x300, 400x400',
        'Maks. Montaj Deliği': '400x400',
        'Taşıma Kapasitesi': '40kg (88lbs)',
        'Dayanıklılık Testi': '4 Kat Onaylı',
        'Yön Göstergesi': 'Hayır',
        'Kablo Yönetimi': 'Var',
        'Renk': 'Mat Siyah & Ceviz, Mat Beyaz & Kayın',
        'Taşıma Kapasitesi (Depolama Dolabı)': '10kg (22lbs)',
        'Aksesuarlar': 'TV Devrilme Önleyici Kayış',
        'Aksesuar Paketi': 'Bölmeli Polietilen Torba',
        'Masif Ahşap Dahil': 'Evet'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/zwymuopr_GROK%20%20TVA36-4365-B4AF2%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/a8utp19u_TVA36-4365-B4AF2%20%20%201%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/gicglaxh_TVA36-4365-B4AF2%20%20%202%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/buqvy3vf_TVA36-4365-B4AF2%20%20%203%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/1zxwpkk0_TVA36-4365-B4AF2%20%20%204%20.png'
    ],
    imagesTr: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/zwymuopr_GROK%20%20TVA36-4365-B4AF2%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/a8utp19u_TVA36-4365-B4AF2%20%20%201%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/vv1cq9uf_TVA36-4365-B4AF2%20%20%202T%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/hso8xf56_TVA36-4365-B4AF2%20%20%203T%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/1zxwpkk0_TVA36-4365-B4AF2%20%20%204%20.png'
    ]
  },
  {
    id: 'tv5',
    name: 'TVA29-4970-B4AF2',
    model: 'TVA29-4970-B4AF2',
    displayName: {
      en: 'Scandinavian Easel Studio TV Floor Stand\nBringing Style & Function to the Living Space',
      tr: 'İskandinav Tarzı Şövale Stüdyo TV Yer Standı\nYaşam Alanına Stil ve İşlevsellik Getiriyor'
    },
    category: 'TV Stands',
    type: 'office',
    shortDesc: {
      en: 'Bringing Style & Function to the Living Space',
      tr: 'Yaşam Alanına Stil ve İşlevsellik Getiriyor'
    },
    fullDesc: {
      en: 'The TVA29-4970-B4AF2 Scandinavian Easel Studio TV Floor Stand breaks the boring rule of traditional TV stands by turning themselves into multi-function products. The four-legged structure offers stability and safety in any living or open area. The open design below the TV to cater different tastes. And the cable management system maintains a clean look.',
      tr: 'TVA29-4970-B4AF2 İskandinav Tarzı Şövale Stüdyo TV Yer Standı, geleneksel TV standlarının sıkıcı kurallarını yıkarak kendilerini çok işlevli ürünlere dönüştürür. Dört ayaklı yapı, herhangi bir yaşam alanında veya açık alanda stabilite ve güvenlik sunar. TV\'nin altındaki açık tasarım farklı zevklere hitap eder. Ve kablo yönetim sistemi temiz bir görünüm sağlar.'
    },
    features: [
      { en: 'Snap Lock: for easier and quick TV assembly', tr: 'Kilit Mekanizması: daha kolay ve hızlı TV montajı için' },
      { en: 'Cable Management: keeps everything organized', tr: 'Kablo Yönetimi: her şeyi düzenli tutar' },
      { en: 'Safety Kits Included: all hardwares to prevent accidental tipping', tr: 'Güvenlik Kiti Dahil: kazara devrilmeyi önleyen tüm donanımlar' },
      { en: 'Anti-Skid pads prevent scratches or scuffs', tr: 'Kaymaz pedler çizik ve aşınmaları önler' }
    ],
    specs: {
      en: {
        'Product Category': 'Studio TV Floor Stand',
        'Rank': 'Premium',
        'Material': 'Steel, Aluminum, Plastic',
        'Surface Finish': 'Powder Coating',
        'Dimensions': '1360x825x520mm (53.5"x32.5"x20.5")',
        'Fit Screen Size': '49"-70"',
        'VESA Compatible': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400, 600x400',
        'Max. Mounting Hole': '600x400',
        'Weight Capacity': '40kg (88lbs)',
        'Strength Tested': '4 Times Approved',
        'Direction Indicator': 'Yes',
        'Cable Management': 'Yes',
        'Color': 'Fine Texture White, Fine Texture Space Grey',
        'Accessories': 'TV Anti-Tip Strap',
        'Accessory Kit Package': 'Compartment Polybag',
        'Certification': 'RoHS',
        'Solid Wood Included': 'No'
      },
      tr: {
        'Ürün Kategorisi': 'Stüdyo TV Yer Standı',
        'Segment': 'Premium',
        'Malzeme': 'Çelik, Alüminyum, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Boyutlar': '1360x825x520mm (53.5"x32.5"x20.5")',
        'Uygun Ekran Boyutu': '49"-70"',
        'VESA Uyumlu': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400, 600x400',
        'Maks. Montaj Deliği': '600x400',
        'Taşıma Kapasitesi': '40kg (88lbs)',
        'Dayanıklılık Testi': '4 Kat Onaylı',
        'Yön Göstergesi': 'Evet',
        'Kablo Yönetimi': 'Var',
        'Renk': 'İnce Dokulu Beyaz, İnce Dokulu Uzay Grisi',
        'Aksesuarlar': 'TV Devrilme Önleyici Kayış',
        'Aksesuar Paketi': 'Bölmeli Polietilen Torba',
        'Sertifika': 'RoHS',
        'Masif Ahşap Dahil': 'Hayır'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/78245096_GROK%20TVA29-4970-B4AF2%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/n704s8c1_TVA29-4970-B4AF2%20-%201%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/rpddck8p_TVA29-4970-B4AF2%20-%202%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/m0zoi13w_TVA29-4970-B4AF2%20-%203%20.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/eklyvaqe_TVA29-4970-B4AF2%20-%204%20.png'
    ]
  },
  {
    id: 'o4',
    name: 'VIYERO Dyson Stand',
    category: 'Dyson Stands',
    type: 'office',
    shortDesc: {
      en: 'Elegant stand designed for Dyson vacuum cleaners',
      tr: 'Dyson elektrikli süpürgeler için tasarlanmış şık stand'
    },
    fullDesc: {
      en: 'Keep your Dyson vacuum organized and accessible with the VIYERO Dyson Stand. Sleek design that complements modern homes while providing stable storage for your vacuum and accessories.',
      tr: 'VIYERO Dyson Standı ile Dyson elektrikli süpürgenizi düzenli ve erişilebilir tutun. Modern evlere uyum sağlayan şık tasarım, süpürgeniz ve aksesuarlarınız için stabil depolama sağlar.'
    },
    features: [
      { en: 'Compatible with all Dyson V-series', tr: 'Tüm Dyson V serisi ile uyumlu' },
      { en: 'Accessory storage hooks', tr: 'Aksesuar depolama kancaları' },
      { en: 'Stable base design', tr: 'Stabil taban tasarımı' },
      { en: 'Space-saving vertical storage', tr: 'Alan tasarrufu sağlayan dikey depolama' },
      { en: 'Premium metal construction', tr: 'Premium metal yapı' }
    ],
    specs: {
      en: {
        'Compatibility': 'Dyson V7, V8, V10, V11, V12, V15',
        'Material': 'Powder-coated Steel',
        'Dimensions': '35 x 25 x 120 cm',
        'Weight Capacity': '5kg',
        'Color': 'Black, White'
      },
      tr: {
        'Uyumluluk': 'Dyson V7, V8, V10, V11, V12, V15',
        'Malzeme': 'Toz Boyalı Çelik',
        'Boyutlar': '35 x 25 x 120 cm',
        'Taşıma Kapasitesi': '5kg',
        'Renk': 'Siyah, Beyaz'
      }
    },
    images: [
      'https://images.unsplash.com/photo-1558317374-067fb5f30001?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHx2YWN1dW0lMjBjbGVhbmVyfGVufDB8fHx8MTc2ODMwMjU0MXww&ixlib=rb-4.1.0&q=85'
    ]
  },
  {
    id: 'mtv1',
    name: 'TVS38-1743-W22T',
    model: 'TVS38-1743-W22T',
    displayName: {
      en: 'Chic Display Floor Stand with Casters\nChic design brings cozy warmth to the space',
      tr: 'Şık mobil TV Standı, alternatif renkleri ile ortama uyum sağlar.\nİster yatak odanızda, ister salonunuzda'
    },
    category: 'Mobile TV Stands',
    type: 'office',
    cardImage: 'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/7gp75g11_TVS38-1743-W22T%20-%20FAMILY2.png',
    shortDesc: {
      en: 'Chic design brings cozy warmth to the space',
      tr: 'Şık tasarım mekana sıcak bir hava katar'
    },
    fullDesc: {
      en: 'Combined with aesthetics and practicality, TVS38-1743-W22T is the ultimate mounting solution for the display—perfect for the living room, bedroom, fitness room, etc. Featuring extremely flexible adjustments, including rotating, tilting, swiveling, and height adjustment, the display floor stand allows users to enjoy a comfortable viewing experience. The height-adjustable storage tray provides space for often-used items and accessories. Mobile casters provide smooth and effortless movement.',
      tr: 'Estetik ve pratikliği bir araya getiren TVS38-1743-W22T, ekran için en iyi montaj çözümüdür - oturma odası, yatak odası, fitness salonu vb. için mükemmeldir. Döndürme, eğme, çevirme ve yükseklik ayarı dahil son derece esnek ayarlar sunan ekran yer standı, kullanıcıların rahat bir izleme deneyimi yaşamasını sağlar. Yüksekliği ayarlanabilir depolama tepsisi, sık kullanılan eşyalar ve aksesuarlar için alan sağlar. Mobil tekerlekler pürüzsüz ve zahmetsiz hareket sağlar.'
    },
    features: [
      { en: 'Free-Tilting Design: makes easy forward or backward adjustment for better viewing and reduced glare', tr: 'Serbest Eğim Tasarımı: daha iyi izleme ve azaltılmış yansıma için kolay ileri veya geri ayar sağlar' },
      { en: 'Portrait and Landscape Orientation: matches different viewing needs', tr: 'Dikey ve Yatay Yönlendirme: farklı izleme ihtiyaçlarına uyum sağlar' },
      { en: 'Height Adjustable Equipment Shelf: provides more storage space for accessories', tr: 'Yüksekliği Ayarlanabilir Ekipman Rafı: aksesuarlar için daha fazla depolama alanı sağlar' },
      { en: 'Heavy-Duty Casters: offer smooth mobility with quality that lasts a lifetime', tr: 'Yüksek Taşıma Kapasiteli Tekerlekler: ömür boyu sürecek kaliteyle pürüzsüz hareketlilik sunar' },
      { en: 'Swivel Ability: for multiple screen viewing angles', tr: 'Döndürme Özelliği: çoklu ekran izleme açıları için' },
      { en: 'Height Adjustable: for an optimal viewing position', tr: 'Yükseklik Ayarlı: optimum izleme pozisyonu için' },
      { en: 'Built-in Cable Management: for an organized and neat workspace', tr: 'Dahili Kablo Yönetimi: düzenli ve temiz bir çalışma alanı için' }
    ],
    specs: {
      en: {
        'Product Category': 'TV Floor Stand',
        'Rank': 'Standard',
        'Material': 'Steel, Plastic',
        'Metal Sheet Thickness': 'VESA Panel THK=1.8mm cold-rolled sheet (0.071")',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte White, Matte Black',
        'Dimensions': '406x406x1210mm (16"x16"x47.6")',
        'Column Size': 'φ48mm (φ1.9")',
        'Fit Screen Size': '17"-43"',
        'VESA Compatible': '75x75, 100x100, 100x200, 200x100, 200x200',
        'TV Weight Capacity': '15kg (33lbs)',
        'Strength Tested': '3 Times Approved',
        'Screen Quantity': '1',
        'Tilt Range': '+35°~-35°',
        'Swivel Range': '+90°~-90°',
        'Screen Rotation': '+180°~-180°',
        'TV Height Adjustable': 'Yes',
        'Shelf Weight Capacity': '3kg (6.6lbs)',
        'Shelf Height Adjustable': 'Yes',
        'Cable Management': 'Yes',
        'Base Type': 'Caster',
        '10 Degree Slope Testing': 'No',
        'Accessory Kit Package': 'Normal/Ziplock Polybag, Compartment Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'TV Yer Standı',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Plastik',
        'Metal Sac Kalınlığı': 'VESA Panel THK=1.8mm soğuk haddelenmiş sac (0.071")',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Beyaz, Mat Siyah',
        'Boyutlar': '406x406x1210mm (16"x16"x47.6")',
        'Kolon Boyutu': 'φ48mm (φ1.9")',
        'Uygun Ekran Boyutu': '17"-43"',
        'VESA Uyumlu': '75x75, 100x100, 100x200, 200x100, 200x200',
        'TV Taşıma Kapasitesi': '15kg (33lbs)',
        'Dayanıklılık Testi': '3 Kat Onaylı',
        'Ekran Adedi': '1',
        'Eğim (Tilt) Aralığı': '+35°~-35°',
        'Dönüş (Swivel) Aralığı': '+90°~-90°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'TV Yüksekliği Ayarlanabilir': 'Evet',
        'Raf Taşıma Kapasitesi': '3kg (6.6lbs)',
        'Raf Yüksekliği Ayarlanabilir': 'Evet',
        'Kablo Yönetimi': 'Var',
        'Taban Tipi': 'Tekerlek',
        '10 Derece Eğim Testi': 'Hayır',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba, Bölmeli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/d1dby33a_TVS38-1743-W22T%20%20%20%20%201.png'
    ]
  },
  {
    id: 'mtv2',
    name: 'TVS38-3786-W46T',
    model: 'TVS38-3786-W46T',
    displayName: {
      en: 'Heavy-Duty Rolling TV Floor Stand\nwith Storage Case & Shelf',
      tr: 'Yüksek Taşıma Kapasiteli mobil TV Standı,\nşık rafı sayesinde minimal bir görüntü ve maksimum fonksiyon sunar'
    },
    category: 'Mobile TV Stands',
    type: 'office',
    cardImage: 'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/jp3jl2b0_TVS38-3786-W46T%20%20Office.png',
    cardImageTr: 'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/hjvnbfmg_TVS38-3786-W46T%20%20%20%20T.PNG',
    shortDesc: {
      en: 'Flexibility combines integrated cable management',
      tr: 'Esneklik, entegre kablo yönetimi ile birleşiyor'
    },
    fullDesc: {
      en: 'The TVS38-3786-W46T Heavy-Duty rolling TV Floor Stand is designed with a mobile base that allows for easy relocation. Ideal for use in multiple spaces. The screen can be rotated to portrait or landscape orientation, suitable for daily TV watching and also for promotional display use. The storage case on the head of the stand collects power strips and some other small tools. Besides, there are cable passing holes on the top and bottom of the storage case, which facilitates integrated cable management together with the pole. The storage shelf can keep essentials such as a remote in your reach. This model\'s flexible adjustment of height and tilt angle ensures that people of different figures can enjoy an optimal viewing experience.',
      tr: 'TVS38-3786-W46T Yüksek Taşıma Kapasiteli Tekerlekli TV Yer Standı, kolay yer değiştirmeye olanak tanıyan mobil bir tabanla tasarlanmıştır. Birden fazla alanda kullanım için idealdir. Ekran dikey veya yatay yönlendirmeye döndürülebilir, günlük TV izleme ve ayrıca tanıtım ekranı kullanımı için uygundur. Standın başındaki depolama kutusu, uzatma kabloları ve diğer küçük araçları toplar. Ayrıca, depolama kutusunun üst ve alt kısmında, direkle birlikte entegre kablo yönetimini kolaylaştıran kablo geçiş delikleri bulunmaktadır. Depolama rafı, uzaktan kumanda gibi temel eşyaları elinizin altında tutar. Bu modelin esnek yükseklik ve eğim açısı ayarı, farklı vücut yapılarına sahip kişilerin optimum bir izleme deneyimi yaşamasını sağlar.'
    },
    features: [
      { en: 'Portrait and Landscape Orientation: matches different viewing needs', tr: 'Dikey ve Yatay Yönlendirme: farklı izleme ihtiyaçlarına uyum sağlar' },
      { en: 'Free-Tilting Design: makes easy forward or backward adjustment for better viewing and reduced glare', tr: 'Serbest Eğim Tasarımı: daha iyi izleme ve azaltılmış yansıma için kolay ileri veya geri ayar sağlar' },
      { en: 'Height Adjustable Equipment Shelf: provides more storage space for accessories', tr: 'Yüksekliği Ayarlanabilir Ekipman Rafı: aksesuarlar için daha fazla depolama alanı sağlar' },
      { en: 'Built-in Cable Management: for an organized and neat workspace', tr: 'Dahili Kablo Yönetimi: düzenli ve temiz bir çalışma alanı için' },
      { en: 'Height Adjustable TV Mount: for the best viewing experience', tr: 'Yüksekliği Ayarlanabilir TV Montajı: en iyi izleme deneyimi için' },
      { en: 'Hidden Casters in the Base: move smoothly while keeping a simple look', tr: 'Tabanda Gizli Tekerlekler: sade görünümü korurken pürüzsüz hareket sağlar' }
    ],
    specs: {
      en: {
        'Product Category': 'TV Floor Stand',
        'Rank': 'Standard',
        'Material': 'Steel, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte White, Matte Black',
        'Dimensions': '500x500x1340mm (19.7"x19.7"x52.8")',
        'Column Size': 'φ60mm (φ2.4")',
        'Fit Screen Size': '37"-86"',
        'VESA Compatible': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400, 600x400',
        'TV Weight Capacity': '50kg (110lbs)',
        'Strength Tested': '3 Times Approved',
        'Screen Quantity': '1',
        'Tilt Range': '+5°~-10°',
        'Screen Rotation': '0°~+90°',
        'TV Height Adjustable': 'Yes',
        'Shelf Weight Capacity': '5kg (11lbs)',
        'Shelf Height Adjustable': 'Yes',
        'Cable Management': 'Yes',
        'Base Type': 'Caster',
        'Accessory Kit Package': 'Normal/Ziplock Polybag, Compartment Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'TV Yer Standı',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Beyaz, Mat Siyah',
        'Boyutlar': '500x500x1340mm (19.7"x19.7"x52.8")',
        'Kolon Boyutu': 'φ60mm (φ2.4")',
        'Uygun Ekran Boyutu': '37"-86"',
        'VESA Uyumlu': '200x200, 300x200, 400x200, 300x300, 400x300, 400x400, 600x400',
        'TV Taşıma Kapasitesi': '50kg (110lbs)',
        'Dayanıklılık Testi': '3 Kat Onaylı',
        'Ekran Adedi': '1',
        'Eğim (Tilt) Aralığı': '+5°~-10°',
        'Ekran Rotasyonu': '0°~+90°',
        'TV Yüksekliği Ayarlanabilir': 'Evet',
        'Raf Taşıma Kapasitesi': '5kg (11lbs)',
        'Raf Yüksekliği Ayarlanabilir': 'Evet',
        'Kablo Yönetimi': 'Var',
        'Taban Tipi': 'Tekerlek',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba, Bölmeli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/jp3jl2b0_TVS38-3786-W46T%20%20Office.png',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/3bt4v6v3_TVS38-3786-W46T%20%20%20%20%20%201-1.PNG'
    ],
    imagesTr: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/hjvnbfmg_TVS38-3786-W46T%20%20%20%20T.PNG',
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/su54zj6q_TVS38-3786-W46T%20%20%20%20%20%201T.PNG'
    ]
  },
  {
    id: 'mtv3',
    name: 'TVS57-1743-W22T',
    model: 'TVS57-1743-W22T',
    displayName: {
      en: 'Fully-Adjustable Mobile Mechanical Spring\nDisplay Floor Stand',
      tr: 'Tam Ayarlanabilir Mobil Mekanik Yaylı\nEkran Yer Standı'
    },
    category: 'Mobile TV Stands',
    type: 'office',
    cardImage: 'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/6ugezyfg_TVS57-1743-W22T%20%20%20%203.png',
    shortDesc: {
      en: 'Max. VESA: 200x200',
      tr: 'Maks. VESA: 200x200'
    },
    fullDesc: {
      en: 'Designed with precision and adaptability, the Fully-Adjustable Mobile Mechanical Spring Display Floor Stand features a smooth spring system for seamless height and angle adjustments. Its mobile base allows for easy relocation, making it ideal for use in multi-purpose spaces like homes, offices, conference rooms, and trade shows. Quick-release VESA plate allows easy installation and removal. Integrated cable management keeps cables hidden and organized. Hidden castors move smoothly and look simpler.',
      tr: 'Hassasiyet ve uyarlanabilirlikle tasarlanan Tam Ayarlanabilir Mobil Mekanik Yaylı Ekran Yer Standı, kesintisiz yükseklik ve açı ayarları için pürüzsüz bir yay sistemine sahiptir. Mobil tabanı kolay yer değiştirmeye olanak tanır, bu da onu evler, ofisler, konferans odaları ve ticari fuarlar gibi çok amaçlı alanlar için ideal kılar. Hızlı çıkarma VESA plakası kolay kurulum ve çıkarma sağlar. Entegre kablo yönetimi kabloları gizli ve düzenli tutar. Gizli tekerlekler pürüzsüz hareket eder ve daha sade görünür.'
    },
    features: [
      { en: 'Quick-Release VESA Plate: for easy installation and removal', tr: 'Hızlı Çıkarma VESA Plakası: kolay kurulum ve çıkarma için' },
      { en: 'Cable Management: keeps everything organized', tr: 'Kablo Yönetimi: her şeyi düzenli tutar' },
      { en: 'Free-Tilting Design: makes easy forward or backward adjustment for better viewing and reduced glare', tr: 'Serbest Eğim Tasarımı: daha iyi izleme ve azaltılmış yansıma için kolay ileri veya geri ayar sağlar' },
      { en: '360° Rotary VESA Plate: for more viewing experience', tr: '360° Döner VESA Plakası: daha iyi izleme deneyimi için' },
      { en: 'Built-in Spring Tension Mechanism: for perfect weight adjustments', tr: 'Dahili Yay Gerginlik Mekanizması: mükemmel ağırlık ayarları için' },
      { en: 'Hidden Casters in the Base: move smoothly while keeping a simple look', tr: 'Tabanda Gizli Tekerlekler: sade görünümü korurken pürüzsüz hareket sağlar' },
      { en: 'Swivel Ability: for multiple screen viewing angles', tr: 'Döndürme Özelliği: çoklu ekran izleme açıları için' }
    ],
    specs: {
      en: {
        'Product Category': 'TV Floor Stand',
        'Rank': 'Standard',
        'Material': 'Aluminum, Steel, Plastic',
        'Surface Finish': 'Powder Coating',
        'Color': 'Matte White, Matte Black',
        'Dimensions': '410x410x1222mm (16.1"x16.1"x48.1")',
        'Fit Screen Size': '17"-43"',
        'VESA Compatible': '75x75, 100x100, 200x100, 200x200',
        'TV Weight Capacity': '5~17kg (11~37.4lbs)',
        'Strength Tested': '2 Times Approved',
        'Screen Quantity': '1',
        'Tilt Range': '+75°~-45°',
        'Swivel Range': '+20°~-20°',
        'Screen Rotation': '+180°~-180°',
        'TV Height Adjustable': 'Yes',
        'Height Range': '166mm (6.5")',
        'Cable Management': 'Yes',
        'Base Type': 'Caster',
        '10 Degree Slope Testing': 'No',
        'Accessory Kit Package': 'Normal/Ziplock Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'TV Yer Standı',
        'Segment': 'Standart',
        'Malzeme': 'Alüminyum, Çelik, Plastik',
        'Yüzey Kaplaması': 'Toz Boya',
        'Renk': 'Mat Beyaz, Mat Siyah',
        'Boyutlar': '410x410x1222mm (16.1"x16.1"x48.1")',
        'Uygun Ekran Boyutu': '17"-43"',
        'VESA Uyumlu': '75x75, 100x100, 200x100, 200x200',
        'TV Taşıma Kapasitesi': '5~17kg (11~37.4lbs)',
        'Dayanıklılık Testi': '2 Kat Onaylı',
        'Ekran Adedi': '1',
        'Eğim (Tilt) Aralığı': '+75°~-45°',
        'Dönüş (Swivel) Aralığı': '+20°~-20°',
        'Ekran Rotasyonu (Pivot)': '+180°~-180°',
        'TV Yüksekliği Ayarlanabilir': 'Evet',
        'Yükseklik Aralığı': '166mm (6.5")',
        'Kablo Yönetimi': 'Var',
        'Taban Tipi': 'Tekerlek',
        '10 Derece Eğim Testi': 'Hayır',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_gaming-office-hub/artifacts/6ugezyfg_TVS57-1743-W22T%20%20%20%203.png'
    ]
  },
  {
    id: 'acc2',
    name: 'PS5-TW-04',
    model: 'PS5-TW-04',
    displayName: {
      en: 'Pole-Mounted Holder for\nPS5 and Switch',
      tr: 'PS5 ve Switch için\nDirek Montajlı Tutucu'
    },
    category: 'Accessories',
    type: 'office',
    shortDesc: {
      en: 'Compatible with Display Floor Stands',
      tr: 'Zemin Tipi TV Standlarıyla Uyumlu'
    },
    fullDesc: {
      en: 'With an easy-to-install pole clamp, PS5-TW-04 is the ultimate storage solution for display floor stands. It keeps the Sony PlayStation 5 and Nintendo Switch in an easy-to-reach location to maximize space while creating an organized appearance. The holders organize headsets and gaming controllers for a clean look. It is a must-have accessory that combines functionality and aesthetics.',
      tr: 'Kolay kurulumlu direk kelepçesi ile PS5-TW-04, zemin tipi TV standları için en iyi depolama çözümüdür. Sony PlayStation 5 ve Nintendo Switch\'i kolay erişilebilir bir konumda tutarak alanı maksimize eder ve düzenli bir görünüm sağlar. Tutucular, kulaklıkları ve oyun kumandalarını temiz bir görünüm için düzenler. İşlevselliği ve estetiği bir arada sunan olmazsa olmaz bir aksesuardır.'
    },
    features: [
      { en: 'Pole Clamp: attaches to circular tube firmly', tr: 'Direk Kelepçesi: dairesel boruya sıkıca tutunur' },
      { en: 'Controller and Headset Holders: organize accessories for easy access', tr: 'Kumanda ve Kulaklık Tutucuları: aksesuarları kolay erişim için düzenler' },
      { en: 'Sturdy Steel Construction: provides a solid and long-lasting performance', tr: 'Sağlam Çelik Yapı: sağlam ve uzun ömürlü performans sağlar' }
    ],
    specs: {
      en: {
        'Product Category': 'Game Console Bracket',
        'Rank': 'Standard',
        'Material': 'Steel, Plastic, Silicone, EVA',
        'Surface Finish': 'Powder Coating',
        'Dimensions': '270x300x141mm (10.6"x11.8"x5.6")',
        'Fit Pole Diameter': 'φ48mm/50x50xR10mm (φ1.9"/2"x2"xR0.39")',
        'Weight Capacity': '5kg (11lbs)',
        'Strength Tested': '2 Times Approved',
        'Installation': 'Clamp',
        'Color': 'Matte Black, Matte White',
        'Accessory Kit Package': 'Normal/Ziplock Polybag'
      },
      tr: {
        'Ürün Kategorisi': 'Oyun Konsolu Braketi',
        'Segment': 'Standart',
        'Malzeme': 'Çelik, Plastik, Silikon, EVA',
        'Yüzey Kaplaması': 'Toz Boya',
        'Boyutlar': '270x300x141mm (10.6"x11.8"x5.6")',
        'Uygun Direk Çapı': 'φ48mm/50x50xR10mm (φ1.9"/2"x2"xR0.39")',
        'Taşıma Kapasitesi': '5kg (11lbs)',
        'Dayanıklılık Testi': '2 Kat Onaylı',
        'Kurulum': 'Kelepçe',
        'Renk': 'Mat Siyah, Mat Beyaz',
        'Aksesuar Paketi': 'Normal/Kilitli Polietilen Torba'
      }
    },
    images: [
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/s5pkdhdx_PS5%201.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/n52pfw3e_PS5%202.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/tw210pua_PS5%203.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/2y20m49o_PS5%204.PNG',
      'https://customer-assets.emergentagent.com/job_premium-ergonomics/artifacts/bna2mfkb_PS5%205.PNG'
    ]
  }
];

export const brandInfo = {
  name: 'VIYERO',
  tagline: 'Engineering Excellence in Every Detail',
  mission: 'At VIYERO, we believe that exceptional design and ergonomic innovation shouldn\'t be compromised. Whether you\'re conquering digital worlds or building your professional future, our products are engineered to elevate your experience.',
  values: [
    {
      title: 'Premium Quality',
      description: 'Every VIYERO product undergoes rigorous testing to ensure it meets our uncompromising standards.'
    },
    {
      title: 'Ergonomic Innovation',
      description: 'We design with your health and comfort in mind, backed by ergonomic research and engineering expertise.'
    },
    {
      title: 'Timeless Design',
      description: 'Our products blend seamlessly into your space with clean aesthetics that age gracefully.'
    }
  ],
  contact: {
    email: 'info@viyero.com',
    address: 'VIYERO Headquarters, Innovation District'
  }
};

export const categories = {
  gaming: [
    { name: 'Monitor Arms', count: 1 },
    { name: 'Gaming Desks', count: 1 },
    { name: 'Accessories', count: 1 }
  ],
  office: [
    { name: 'Monitor Arms', count: 1 },
    { name: 'Office Desks', count: 1 },
    { name: 'Accessories', count: 1 }
  ]
};
